(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6280],{

/***/ 15736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useFormControl; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * @ignore - internal component.
 */

var FormControlContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext();

if (false) {}

function useFormControl() {
  return react__WEBPACK_IMPORTED_MODULE_0__.useContext(FormControlContext);
}
/* harmony default export */ __webpack_exports__["Z"] = (FormControlContext);

/***/ }),

/***/ 22601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useFormControl; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _FormControlContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15736);


function useFormControl() {
  return react__WEBPACK_IMPORTED_MODULE_0__.useContext(_FormControlContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
}

/***/ }),

/***/ 31932:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[username]",
      function () {
        return __webpack_require__(34930);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 65098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59492);
/* harmony import */ var _CustomSwitch_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88859);
/* harmony import */ var _CustomSwitch_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_CustomSwitch_module_scss__WEBPACK_IMPORTED_MODULE_1__);



var CustomSwitch = function(param) {
    var enable = param.enable, handleChange = param.handleChange, titleOn = param.titleOn, titleOff = param.titleOff, id = param.id, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_CustomSwitch_module_scss__WEBPACK_IMPORTED_MODULE_1___default().customSwitch),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_CustomSwitch_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["switch"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_CustomSwitch_module_scss__WEBPACK_IMPORTED_MODULE_1___default().flag),
                    children: enable ? titleOn : titleOff
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    focusVisibleClassName: (_CustomSwitch_module_scss__WEBPACK_IMPORTED_MODULE_1___default().focusVisible),
                    disableRipple: true,
                    classes: {
                        root: (_CustomSwitch_module_scss__WEBPACK_IMPORTED_MODULE_1___default().root),
                        switchBase: (_CustomSwitch_module_scss__WEBPACK_IMPORTED_MODULE_1___default().switchBase),
                        thumb: (_CustomSwitch_module_scss__WEBPACK_IMPORTED_MODULE_1___default().thumb),
                        track: (_CustomSwitch_module_scss__WEBPACK_IMPORTED_MODULE_1___default().track),
                        checked: (_CustomSwitch_module_scss__WEBPACK_IMPORTED_MODULE_1___default().checked)
                    },
                    disabled: disabled,
                    checked: enable,
                    onChange: function() {
                        return handleChange(!enable);
                    },
                    name: id,
                    id: id
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomSwitch);


/***/ }),

/***/ 14097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22467);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var components_common_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37975);
/* harmony import */ var _Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97514);
/* harmony import */ var _Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_5__);







var Dropdown = function(param) {
    var items = param.items, onChangeValue = param.onChangeValue, className = param.className, currentValue = param.currentValue, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "選択してください" : _placeholder, title = param.title, _isToggleRight = param.isToggleRight, isToggleRight = _isToggleRight === void 0 ? false : _isToggleRight, _limitHeightItems = param.limitHeightItems, limitHeightItems = _limitHeightItems === void 0 ? false : _limitHeightItems, _showCustomLabel = param.showCustomLabel, showCustomLabel = _showCustomLabel === void 0 ? false : _showCustomLabel;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), show = ref[0], setShow = ref[1];
    var dropdownRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var currentItem = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return items.find(function(i) {
            return i.value === currentValue;
        });
    }, [
        currentValue,
        items
    ]);
    (0,common_utils__WEBPACK_IMPORTED_MODULE_2__/* .useOutsideClick */ .O3)(dropdownRef, function() {
        if (show) setShow(false);
    });
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_5___default().dropdown), className !== null && className !== void 0 ? className : ""),
        ref: dropdownRef,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_5___default().value), "value"),
                onClick: function() {
                    return setShow(!show);
                },
                tabIndex: 0,
                children: [
                    currentItem ? showCustomLabel ? (currentItem === null || currentItem === void 0 ? void 0 : currentItem.customLabel) || "" : (currentItem === null || currentItem === void 0 ? void 0 : currentItem.label) || "" : placeholder,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_5___default().caret),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                            name: "sort-arrow",
                            width: 9,
                            height: 9
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_5___default().menuWrapper), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, (_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_5___default().toogleRight), isToggleRight), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, (_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_5___default().limitHeightItems), limitHeightItems), _obj)),
                style: {
                    display: show ? "block" : "none"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_5___default().items),
                    children: [
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_5___default().title),
                            children: title
                        }),
                        items.map(function(item, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item), "item"),
                                onClick: function() {
                                    onChangeValue(item.value);
                                    setShow(false);
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_5___default().check),
                                        children: item.value === currentValue && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                            name: "checked",
                                            width: 12,
                                            height: 12
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_5___default().label),
                                        children: item.label
                                    })
                                ]
                            }, "item-".concat(index));
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Dropdown);


/***/ }),

/***/ 25222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22467);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _HelpPopover_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16980);
/* harmony import */ var _HelpPopover_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_HelpPopover_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var HelpPopover = function(param) {
    var content = param.content, _tooltipWidth = param.tooltipWidth, tooltipWidth = _tooltipWidth === void 0 ? 220 : _tooltipWidth, className = param.className, iconElement = param.iconElement, tooltipClassname = param.tooltipClassname;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), show = ref[0], setShow = ref[1];
    var tooltipRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
    (0,common_utils__WEBPACK_IMPORTED_MODULE_2__/* .useOutsideClick */ .O3)(tooltipRef, function() {
        if (show) setShow(false);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_HelpPopover_module_scss__WEBPACK_IMPORTED_MODULE_4___default().help), className),
        ref: tooltipRef,
        onMouseEnter: function() {
            return setShow(true);
        },
        children: [
            iconElement ? iconElement : "?",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_HelpPopover_module_scss__WEBPACK_IMPORTED_MODULE_4___default().tooltip), tooltipClassname),
                style: {
                    display: show ? "" : "none",
                    width: "".concat(tooltipWidth, "px")
                },
                children: content
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HelpPopover);


/***/ }),

/***/ 58657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _InputWithLabel_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4414);
/* harmony import */ var _InputWithLabel_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_InputWithLabel_module_scss__WEBPACK_IMPORTED_MODULE_2__);




// import classNames from 'classnames';
var InputWithLabelV2 = function(param) {
    var title = param.title, children = param.children, _error = param.error, error = _error === void 0 ? "" : _error, className = param.className, _style = param.style, style = _style === void 0 ? {} : _style, _required = param.required, required = _required === void 0 ? false : _required, _requiredAlert = param.requiredAlert, requiredAlert = _requiredAlert === void 0 ? false : _requiredAlert;
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_InputWithLabel_module_scss__WEBPACK_IMPORTED_MODULE_2___default().inputGroup),
        style: style,
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_InputWithLabel_module_scss__WEBPACK_IMPORTED_MODULE_2___default().header),
                children: [
                    title,
                    required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_InputWithLabel_module_scss__WEBPACK_IMPORTED_MODULE_2___default().requiredFlag),
                        children: "*"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_InputWithLabel_module_scss__WEBPACK_IMPORTED_MODULE_2___default().value), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, className, !!className), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_InputWithLabel_module_scss__WEBPACK_IMPORTED_MODULE_2___default().requiredAlert), requiredAlert), _obj)),
                children: children
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_InputWithLabel_module_scss__WEBPACK_IMPORTED_MODULE_2___default().error),
                children: error
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InputWithLabelV2);


/***/ }),

/***/ 34930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _username_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-tabs/esm/index.js + 10 modules
var esm = __webpack_require__(78369);
// EXTERNAL MODULE: ./components/Profile/index.tsx + 5 modules
var Profile = __webpack_require__(84499);
// EXTERNAL MODULE: ./components/TimelineSection/index.tsx
var TimelineSection = __webpack_require__(32954);
// EXTERNAL MODULE: ./store/timeline.ts
var timeline = __webpack_require__(12800);
// EXTERNAL MODULE: ./store/global.ts
var global = __webpack_require__(8405);
// EXTERNAL MODULE: ./common/interfaces/api.ts
var api = __webpack_require__(21694);
// EXTERNAL MODULE: ./config/env.ts
var env = __webpack_require__(36514);
// EXTERNAL MODULE: ./components/common/Icon/index.tsx
var Icon = __webpack_require__(37975);
// EXTERNAL MODULE: ./common/utils/index.ts + 1 modules
var utils = __webpack_require__(22467);
// EXTERNAL MODULE: ./pages/[username]/ProfilePage.module.scss
var ProfilePage_module = __webpack_require__(35214);
var ProfilePage_module_default = /*#__PURE__*/__webpack_require__.n(ProfilePage_module);
// EXTERNAL MODULE: ./components/CreatePostBox/index.tsx
var CreatePostBox = __webpack_require__(87824);
// EXTERNAL MODULE: ./service/user.ts
var user = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/atoms/CustomSwitch/index.tsx
var CustomSwitch = __webpack_require__(65098);
// EXTERNAL MODULE: ./components/common/Button/index.tsx
var Button = __webpack_require__(98133);
// EXTERNAL MODULE: ./components/common/Dropdown/index.tsx
var Dropdown = __webpack_require__(14097);
// EXTERNAL MODULE: ./components/common/DropdownWithSearch/Dropdown.module.scss
var Dropdown_module = __webpack_require__(18370);
var Dropdown_module_default = /*#__PURE__*/__webpack_require__.n(Dropdown_module);
;// CONCATENATED MODULE: ./components/common/DropdownWithSearch/index.tsx







var DropdownWithSearch = function(param) {
    var items = param.items, onChangeValue = param.onChangeValue, className = param.className, currentValue = param.currentValue, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "選択してください" : _placeholder, title = param.title, _isToggleRight = param.isToggleRight, isToggleRight = _isToggleRight === void 0 ? false : _isToggleRight, _limitHeightItems = param.limitHeightItems, limitHeightItems = _limitHeightItems === void 0 ? false : _limitHeightItems, _ignoreValues = param.ignoreValues, ignoreValues = _ignoreValues === void 0 ? [] : _ignoreValues;
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var dropdownRef = (0,react.useRef)();
    var currentItem = (0,react.useMemo)(function() {
        return items.find(function(i) {
            return i.value === currentValue;
        });
    }, [
        currentValue,
        items
    ]);
    var ref1 = (0,react.useState)((currentItem === null || currentItem === void 0 ? void 0 : currentItem.label) || ""), keyword = ref1[0], setKeyword = ref1[1];
    var showingItems = (0,react.useMemo)(function() {
        var currentItems = items;
        if (keyword) {
            currentItems = currentItems.filter(function(itm) {
                var ref, ref1, ref2, ref3, ref4, ref5;
                return ((ref2 = (ref1 = (ref = itm.label) === null || ref === void 0 ? void 0 : ref.toString()) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === null || ref2 === void 0 ? void 0 : ref2.includes(keyword.toLowerCase())) || ((ref5 = (ref4 = (ref3 = itm.value) === null || ref3 === void 0 ? void 0 : ref3.toString()) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()) === null || ref5 === void 0 ? void 0 : ref5.includes(keyword.toLowerCase()));
            });
        }
        if (ignoreValues.length > 0) {
            var currentIgnoreValues = currentItem ? ignoreValues.filter(function(val) {
                return val !== (currentItem === null || currentItem === void 0 ? void 0 : currentItem.value);
            }) : ignoreValues;
            currentItems = currentItems.filter(function(itm) {
                return !currentIgnoreValues.includes(itm.value);
            });
        }
        return currentItems;
    }, [
        items,
        keyword,
        ignoreValues,
        currentItem
    ]);
    (0,utils/* useOutsideClick */.O3)(dropdownRef, function() {
        if (show) setShow(false);
    });
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((Dropdown_module_default()).dropdown, className !== null && className !== void 0 ? className : ""),
        ref: dropdownRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Dropdown_module_default()).value, "value"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "text",
                        placeholder: placeholder,
                        value: keyword,
                        onChange: function(e) {
                            setKeyword(e.target.value);
                        },
                        onClick: function() {
                            return setShow(true);
                        }
                    }),
                    keyword && show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Dropdown_module_default()).close,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "close",
                            width: 14,
                            height: 14,
                            onClick: function() {
                                setKeyword("");
                                onChangeValue(null);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Dropdown_module_default()).caret,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "sort-arrow",
                            width: 9,
                            height: 9,
                            onClick: function() {
                                return setShow(!show);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Dropdown_module_default()).menuWrapper, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (Dropdown_module_default()).toogleRight, isToggleRight), (0,_define_property/* default */.Z)(_obj, (Dropdown_module_default()).limitHeightItems, limitHeightItems), _obj)),
                style: {
                    display: show ? "block" : "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Dropdown_module_default()).items,
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Dropdown_module_default()).title,
                            children: title
                        }),
                        showingItems.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((Dropdown_module_default()).item, "item"),
                                onClick: function() {
                                    onChangeValue(item.value);
                                    setKeyword(item.label);
                                    setShow(false);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (Dropdown_module_default()).check,
                                        children: item.value === currentValue && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                            name: "checked",
                                            width: 12,
                                            height: 12
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (Dropdown_module_default()).label,
                                        children: item.label
                                    })
                                ]
                            }, "item-".concat(index));
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var common_DropdownWithSearch = (DropdownWithSearch);

// EXTERNAL MODULE: ./components/common/HelpPopover/index.tsx
var HelpPopover = __webpack_require__(25222);
// EXTERNAL MODULE: ./lib/dayjs.ts
var dayjs = __webpack_require__(25916);
// EXTERNAL MODULE: ./components/modules/InputProfileSection/InputProfileSection.module.scss
var InputProfileSection_module = __webpack_require__(32409);
var InputProfileSection_module_default = /*#__PURE__*/__webpack_require__.n(InputProfileSection_module);
;// CONCATENATED MODULE: ./components/modules/InputProfileSection/InputLanguages/index.tsx










var InputLanguages = function() {
    var ref = (0,react.useContext)(InputProfileSectionContext), languages = ref.languages, languageLevels = ref.languageLevels, fetchedUserInfo = ref.fetchedUserInfo, updateUserInfo = ref.updateUserInfo;
    var ref1 = (0,react.useState)((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.profile_languages) || []), currentLanguages = ref1[0], setCurrentLanguages = ref1[1];
    var languagesOptions = (0,react.useMemo)(function() {
        return languages.map(function(lan) {
            return {
                label: lan.name_jap,
                value: lan.id
            };
        });
    }, [
        languages
    ]);
    var languageLevelsOptions = (0,react.useMemo)(function() {
        return languageLevels.map(function(lv) {
            return {
                label: lv.name,
                value: lv.id
            };
        });
    }, [
        languageLevels
    ]);
    var ref2 = (0,react.useState)(false), isEditMode = ref2[0], setEditMode = ref2[1];
    var ignoreLanguageIds = (0,react.useMemo)(function() {
        return currentLanguages.map(function(lan) {
            return lan.language_id;
        });
    }, [
        currentLanguages
    ]);
    (0,react.useEffect)(function() {
        if (!isEditMode) {
            setCurrentLanguages((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.profile_languages) || []);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.profile_languages
    ]);
    var addBlankLanguage = function() {
        var newLanguages = (0,utils/* clone */.d9)(currentLanguages);
        newLanguages.push({
            language_id: null,
            level: ""
        });
        setCurrentLanguages(newLanguages);
    };
    var handleChangeLanguage = function(index, languageId) {
        var newLanguages = (0,utils/* clone */.d9)(currentLanguages);
        var currentLan = newLanguages[index];
        var newLan = languages.find(function(lan) {
            return lan.id === languageId;
        });
        if (!newLan) return;
        var newLanguage = {
            language_id: newLan.id,
            level: currentLan === null || currentLan === void 0 ? void 0 : currentLan.level
        };
        newLanguages[index] = newLanguage;
        setCurrentLanguages(newLanguages);
    };
    var handleChangeLevel = function(index, levelId) {
        var ref;
        var newLanguages = (0,utils/* clone */.d9)(currentLanguages);
        var newLevel = (ref = languageLevels.find(function(lv) {
            return lv.id === levelId;
        })) === null || ref === void 0 ? void 0 : ref.id;
        newLanguages[index].level = newLevel;
        setCurrentLanguages(newLanguages);
    };
    var deleteLanguage = function(index) {
        var newLanguages = (0,utils/* clone */.d9)(currentLanguages);
        newLanguages.splice(index, 1);
        setCurrentLanguages(newLanguages);
    };
    (0,react.useEffect)(function() {
        if (isEditMode && currentLanguages.length === 0) {
            addBlankLanguage();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isEditMode
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputInfoSubGroup, {
        name: "言語",
        isEditMode: isEditMode,
        setEditMode: setEditMode,
        onSave: function() {
            var newLans = currentLanguages.filter(function(lan) {
                return !!lan.language_id && lan.language_id > 0 && !!lan.level;
            });
            setCurrentLanguages(newLans);
            updateUserInfo({
                profile_languages: newLans
            });
        },
        onCancel: function() {
            setCurrentLanguages((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.profile_languages) || []);
        },
        children: isEditMode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (InputProfileSection_module_default()).languagesEditMode,
            children: [
                currentLanguages.map(function(lan, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (InputProfileSection_module_default()).languageItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (InputProfileSection_module_default()).index,
                                children: [
                                    index + 1,
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (InputProfileSection_module_default()).languageSelect,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_DropdownWithSearch, {
                                    items: languagesOptions,
                                    placeholder: "言語を検索する",
                                    limitHeightItems: true,
                                    className: (InputProfileSection_module_default()).customDropdown,
                                    currentValue: lan.language_id,
                                    title: "",
                                    ignoreValues: ignoreLanguageIds,
                                    onChangeValue: function(val) {
                                        return handleChangeLanguage(index, val);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (InputProfileSection_module_default()).languageLevelSelect,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                                    items: languageLevelsOptions,
                                    placeholder: "言語のレベル",
                                    limitHeightItems: true,
                                    className: (InputProfileSection_module_default()).customDropdown,
                                    currentValue: lan.level,
                                    title: "",
                                    onChangeValue: function(val) {
                                        return handleChangeLevel(index, val);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (InputProfileSection_module_default()).deleteIcon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                    name: "delete-trash",
                                    height: 24,
                                    width: 24,
                                    onClick: function() {
                                        return deleteLanguage(index);
                                    }
                                })
                            })
                        ]
                    }, "language-object-".concat(lan.id, "-").concat(index));
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (InputProfileSection_module_default()).addLanguage,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        text: "言語を追加",
                        onClick: function() {
                            return addBlankLanguage();
                        }
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (InputProfileSection_module_default()).languages,
            children: [
                (!currentLanguages || currentLanguages.length === 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (InputProfileSection_module_default()).infoShow,
                    children: BLANK_TEXT
                }),
                (currentLanguages || []).map(function(lan, index) {
                    var ref, ref1;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (InputProfileSection_module_default()).languageItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (InputProfileSection_module_default()).name,
                                children: lan === null || lan === void 0 ? void 0 : (ref = lan.language) === null || ref === void 0 ? void 0 : ref.name_jap
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (InputProfileSection_module_default()).level,
                                children: (ref1 = languageLevelsOptions.find(function(op) {
                                    return op.value === lan.level;
                                })) === null || ref1 === void 0 ? void 0 : ref1.label
                            })
                        ]
                    }, "language-object-".concat(lan.id, "-").concat(index));
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/modules/InputProfileSection/InputSkills/index.tsx








// interface SkillGroupType {
//   skill_type: string;
//   skills: ProfileSkillType[];
// }
// const convertSkillsToGroups = (skills: ProfileSkillType[]) => {
//   const types = skills
//     .map((ski) => ski.skill_type)
//     .filter((value, index, array) => array.indexOf(value) === index);
//   return types.map((type) => {
//     return {
//       skill_type: type,
//       skills: skills.filter((sk) => sk.skill_type === type),
//     };
//   });
// };
// const convertGroupsToSkills = (groups: SkillGroupType[]) => {
//   let skis: ProfileSkillType[] = [];
//   groups.forEach((group) => {
//     const newSkills = (group.skills || []).map((sk) => {
//       sk.skill_type = group.skill_type?.trim();
//       return sk;
//     });
//     skis = skis.concat(newSkills);
//   });
//   return skis.filter(
//     (sk) =>
//       sk.skill_type &&
//       sk.name &&
//       sk.exp_period_year >= 0 &&
//       sk.exp_period_month >= 0 &&
//       sk.exp_period_year + sk.exp_period_month > 0
//   );
// };
var InputSkills = function() {
    var ref = (0,react.useContext)(InputProfileSectionContext), fetchedUserInfo = ref.fetchedUserInfo, updateUserInfo = ref.updateUserInfo;
    var ref1 = (0,react.useState)(false), isEditMode = ref1[0], setEditMode = ref1[1];
    var ref2 = (0,react.useState)((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.profile_skills) || []), skills = ref2[0], setSkills = ref2[1];
    (0,react.useEffect)(function() {
        if (!isEditMode) {
            setSkills((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.profile_skills) || []);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.profile_skills
    ]);
    // const addBlankSkillGroup = () => {
    //   const newSkillGroup = clone(skillGroups) as SkillGroupType[];
    //   newSkillGroup.push({
    //     skill_type: '',
    //     skills: [{ name: '', exp_period_year: 1, exp_period_month: 0 }],
    //   });
    //   setSkillGroups(newSkillGroup);
    // };
    // const deleteSkillGroup = (index: number) => {
    //   const newSkillGroup = clone(skillGroups) as SkillGroupType[];
    //   newSkillGroup.splice(index, 1);
    //   setSkillGroups(newSkillGroup);
    // };
    // const changeSkillGroupName = (index: number, newName: string) => {
    //   const newSkillGroup = clone(skillGroups) as SkillGroupType[];
    //   if (!newSkillGroup[index]) return;
    //   newSkillGroup[index].skill_type = newName;
    //   setSkillGroups(newSkillGroup);
    // };
    var addBlankSubSkill = function() {
        var newSkills = (0,utils/* clone */.d9)(skills);
        newSkills.push({
            name: "",
            exp_period_year: 1,
            exp_period_month: 0
        });
        setSkills(newSkills);
    };
    var deleteSubSkill = function(subSkillIndex) {
        var newSkills = (0,utils/* clone */.d9)(skills);
        if (!newSkills[subSkillIndex]) return;
        newSkills.splice(subSkillIndex, 1);
        setSkills(newSkills);
    };
    var changeSubSkillInfo = function(param) {
        var subSkillIndex = param.subSkillIndex, attrName = param.attrName, val = param.val;
        var newSkills = (0,utils/* clone */.d9)(skills);
        if (!newSkills[subSkillIndex]) return;
        newSkills[subSkillIndex][attrName] = val;
        setSkills(newSkills);
    };
    (0,react.useEffect)(function() {
        if (isEditMode && skills.length === 0) {
            addBlankSubSkill();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isEditMode
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputInfoSubGroup, {
        name: "経験・スキル",
        isEditMode: isEditMode,
        setEditMode: setEditMode,
        onSave: function() {
            var newSkills = skills.filter(function(sk) {
                return sk.name && sk.exp_period_year >= 0 && sk.exp_period_month >= 0 && sk.exp_period_year + sk.exp_period_month > 0;
            });
            setSkills(newSkills);
            updateUserInfo({
                profile_skills: newSkills
            });
        },
        onCancel: function() {
            setSkills((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.profile_skills) || []);
        },
        children: isEditMode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (InputProfileSection_module_default()).skillsEditMode,
            children: [
                (skills || []).map(function(ski, skIndex) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (InputProfileSection_module_default()).subItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (InputProfileSection_module_default()).subItemName,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (InputProfileSection_module_default()).subItemIndex,
                                        children: "".concat(skIndex + 1, ".")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "text",
                                        value: ski.name,
                                        maxLength: MAX_ONE_LINE_TEXT_LEN,
                                        className: (InputProfileSection_module_default()).inputTextContentOneLine,
                                        style: {
                                            width: "150px"
                                        },
                                        onChange: function(e) {
                                            return changeSubSkillInfo({
                                                subSkillIndex: skIndex,
                                                attrName: "name",
                                                val: e.target.value
                                            });
                                        },
                                        placeholder: "スキル"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (InputProfileSection_module_default()).subItemYear,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "number",
                                        value: ski.exp_period_year,
                                        min: 0,
                                        max: 100,
                                        style: {
                                            width: "60px",
                                            marginRight: "5px"
                                        },
                                        className: (InputProfileSection_module_default()).inputTextContentOneLine,
                                        onChange: function(e) {
                                            var newVal = parseInt(e.target.value);
                                            if ((0,utils/* isNumber */.hj)(newVal)) {
                                                newVal = Math.min(100, Math.max(newVal, 0));
                                            } else {
                                                newVal = 0;
                                            }
                                            changeSubSkillInfo({
                                                subSkillIndex: skIndex,
                                                attrName: "exp_period_year",
                                                val: newVal
                                            });
                                        }
                                    }),
                                    "年"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (InputProfileSection_module_default()).subItemMonth,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "number",
                                        min: 0,
                                        max: 11,
                                        value: ski.exp_period_month,
                                        style: {
                                            width: "60px",
                                            marginRight: "5px"
                                        },
                                        className: (InputProfileSection_module_default()).inputTextContentOneLine,
                                        onChange: function(e) {
                                            var newVal = parseInt(e.target.value);
                                            if ((0,utils/* isNumber */.hj)(newVal)) {
                                                newVal = Math.min(11, Math.max(newVal, 0));
                                            } else {
                                                newVal = 0;
                                            }
                                            changeSubSkillInfo({
                                                subSkillIndex: skIndex,
                                                attrName: "exp_period_month",
                                                val: newVal
                                            });
                                        }
                                    }),
                                    "カ月"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                name: "delete-trash",
                                height: 24,
                                width: 24,
                                onClick: function() {
                                    return deleteSubSkill(skIndex);
                                }
                            })
                        ]
                    }, "skg-".concat(skIndex));
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (InputProfileSection_module_default()).addSkill,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        text: "スキルを追加",
                        onClick: function() {
                            return addBlankSubSkill();
                        }
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (InputProfileSection_module_default()).skills,
            children: [
                (!skills || skills.length === 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (InputProfileSection_module_default()).infoShow,
                    children: BLANK_TEXT
                }),
                (skills || []).map(function(ski, skIndex) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (InputProfileSection_module_default()).subItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (InputProfileSection_module_default()).subItemName,
                                children: ski.name || BLANK_TEXT
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (InputProfileSection_module_default()).subItemTime,
                                children: [
                                    ski.exp_period_year > 0 && "".concat(ski.exp_period_year, "年"),
                                    ski.exp_period_month > 0 && "".concat(ski.exp_period_month, "カ月")
                                ]
                            })
                        ]
                    }, "skill-".concat(skIndex));
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(18698);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/ja/index.js + 5 modules
var ja = __webpack_require__(40944);
// EXTERNAL MODULE: ./components/common/DateInput/DateInput.module.scss
var DateInput_module = __webpack_require__(86903);
var DateInput_module_default = /*#__PURE__*/__webpack_require__.n(DateInput_module);
;// CONCATENATED MODULE: ./components/common/DateInput/index.tsx







// eslint-disable-next-line @typescript-eslint/no-unsafe-call
(0,react_datepicker_min.registerLocale)("ja", ja/* default */.Z);



var DateInput = function(param) {
    var date = param.date, setDate = param.setDate, _showTimeSelect = param.showTimeSelect, showTimeSelect = _showTimeSelect === void 0 ? false : _showTimeSelect, customDateFormat = param.customDateFormat, maxDate = param.maxDate, _onlyMonthYear = param.onlyMonthYear, onlyMonthYear = _onlyMonthYear === void 0 ? false : _onlyMonthYear, _dateNullText = param.dateNullText, dateNullText = _dateNullText === void 0 ? "" : _dateNullText, _resetSupport = param.resetSupport, resetSupport = _resetSupport === void 0 ? false : _resetSupport;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((DateInput_module_default()).timeInputWrapper, (0,_define_property/* default */.Z)({}, (DateInput_module_default()).withTime, showTimeSelect)),
        onClick: function() {
            return setOpen(true);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                className: (DateInput_module_default()).tableTimeInput,
                type: "text",
                value: date ? (0,dayjs/* default */.Z)(date).format(customDateFormat !== null && customDateFormat !== void 0 ? customDateFormat : "YYYY/MM/DD") : dateNullText,
                readOnly: true
            }),
            resetSupport && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (DateInput_module_default()).close,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                    name: "close",
                    width: 14,
                    height: 14,
                    onClick: function() {
                        setDate(null);
                    }
                })
            }),
            open && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (DateInput_module_default()).datePicker,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datepicker_min_default()), {
                    selected: date ? date : new Date(),
                    onChange: function(date) {
                        return setDate(date);
                    },
                    onYearChange: function(date) {
                        return setDate(date);
                    },
                    onMonthChange: function(date) {
                        return setDate(date);
                    },
                    locale: "ja",
                    showTimeSelect: showTimeSelect,
                    onClickOutside: function() {
                        return setOpen(false);
                    },
                    inline: true,
                    maxDate: maxDate !== null && maxDate !== void 0 ? maxDate : new Date(),
                    showYearDropdown: true,
                    scrollableYearDropdown: true,
                    yearDropdownItemNumber: 100,
                    showMonthYearPicker: onlyMonthYear
                })
            })
        ]
    });
};
/* harmony default export */ var common_DateInput = (DateInput);

// EXTERNAL MODULE: ./components/common/InputWithLabelV2/index.tsx
var InputWithLabelV2 = __webpack_require__(58657);
// EXTERNAL MODULE: ./common/utils/user.ts
var utils_user = __webpack_require__(97542);
;// CONCATENATED MODULE: ./components/modules/InputProfileSection/InputStudyExperiences/index.tsx















var DATE_FORMAT = "YYYY年MM月";
var InputStudyExperiences = function() {
    var ref = (0,react.useContext)(InputProfileSectionContext), fetchedUserInfo = ref.fetchedUserInfo, updateUserInfo = ref.updateUserInfo, educationLevels = ref.educationLevels, educationStatuses = ref.educationStatuses;
    var ref1 = (0,react.useState)(false), isEditMode = ref1[0], setEditMode = ref1[1];
    var ref2 = (0,react.useState)((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.profile_educations) || []), studyExperiences = ref2[0], setStudyExperiences = ref2[1];
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var educationLevelsOptions = (0,react.useMemo)(function() {
        return educationLevels.map(function(lv) {
            return {
                label: lv.name,
                value: lv.id
            };
        });
    }, [
        educationLevels
    ]);
    var educationStatusOptions = (0,react.useMemo)(function() {
        return educationStatuses.map(function(lv) {
            return {
                label: lv.name,
                value: lv.id
            };
        });
    }, [
        educationStatuses
    ]);
    (0,react.useEffect)(function() {
        if (!isEditMode) {
            setStudyExperiences((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.profile_educations) || []);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.profile_educations
    ]);
    var addBlankStudyExperience = function() {
        var newExps = (0,utils/* clone */.d9)(studyExperiences);
        newExps.push({
            school_name: "",
            from: (0,utils_user/* formatDatoToSend */.pz)(),
            to: (0,utils_user/* formatDatoToSend */.pz)(),
            description: "",
            education_level_id: 6,
            status: "graduated"
        });
        setStudyExperiences(newExps);
    };
    var deleteStudyExperience = function(index) {
        var newExps = (0,utils/* clone */.d9)(studyExperiences);
        newExps.splice(index, 1);
        setStudyExperiences(newExps);
    };
    var downPositionStudyExperience = function(index) {
        if (index < 0 || index >= studyExperiences.length - 1) return;
        var newExperiences = (0,utils/* clone */.d9)(studyExperiences);
        var currentEx = newExperiences[index];
        if (!currentEx) return;
        newExperiences[index] = newExperiences[index + 1];
        newExperiences[index + 1] = currentEx;
        setStudyExperiences(newExperiences);
        setSnackbarMessage({
            text: "位置を変更しました",
            type: "success"
        });
    };
    var upPositionStudyExperience = function(index) {
        if (index === 0 || index > studyExperiences.length - 1) return;
        var newExperiences = (0,utils/* clone */.d9)(studyExperiences);
        var currentEx = newExperiences[index];
        if (!currentEx) return;
        newExperiences[index] = newExperiences[index - 1];
        newExperiences[index - 1] = currentEx;
        setStudyExperiences(newExperiences);
        setSnackbarMessage({
            text: "位置を変更しました",
            type: "success"
        });
    };
    var handleChangeExInfo = function(param) {
        var index = param.index, attr = param.attr, val = param.val;
        var newExps = (0,utils/* clone */.d9)(studyExperiences);
        if (!newExps[index]) return;
        newExps[index][attr] = val;
        setStudyExperiences(newExps);
    };
    (0,react.useEffect)(function() {
        if (isEditMode && studyExperiences.length === 0) {
            addBlankStudyExperience();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isEditMode
    ]);
    var hasError = (0,react.useMemo)(function() {
        return studyExperiences.some(function(ex) {
            var ref;
            return !((ref = ex.school_name) === null || ref === void 0 ? void 0 : ref.trim()) || !ex.education_level_id || !ex.status;
        });
    }, [
        studyExperiences
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputInfoSubGroup, {
        name: "最終学歴",
        isEditMode: isEditMode,
        setEditMode: setEditMode,
        disableSave: hasError,
        errorText: hasError ? "必須項目を入力してください" : "",
        onSave: function() {
            var newExs = studyExperiences.filter(function(ex) {
                var ref;
                return !!((ref = ex.school_name) === null || ref === void 0 ? void 0 : ref.trim()) && !!ex.education_level_id && !!ex.status;
            });
            setStudyExperiences(newExs);
            updateUserInfo({
                profile_educations: newExs
            });
        },
        onCancel: function() {
            setStudyExperiences((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.profile_educations) || []);
        },
        children: isEditMode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (InputProfileSection_module_default()).studyExperiencesEditMode,
            children: [
                studyExperiences.map(function(stdEx, index) {
                    var ref, ref1;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (InputProfileSection_module_default()).studyExperience,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (InputProfileSection_module_default()).studyName,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (InputProfileSection_module_default()).exIndex,
                                        children: [
                                            index + 1,
                                            "."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                                        required: true,
                                        title: "学校名",
                                        style: {
                                            marginRight: "15px",
                                            width: "200px"
                                        },
                                        requiredAlert: !((ref = stdEx.school_name) === null || ref === void 0 ? void 0 : ref.trim()),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            value: stdEx.school_name,
                                            className: (InputProfileSection_module_default()).inputTextContentOneLine,
                                            placeholder: "学校名",
                                            name: "school_name",
                                            maxLength: MAX_ONE_LINE_TEXT_LEN,
                                            onChange: function(e) {
                                                return handleChangeExInfo({
                                                    index: index,
                                                    attr: "school_name",
                                                    val: e.target.value
                                                });
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                                        title: "タイプ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                                            items: educationLevelsOptions,
                                            placeholder: "タイプを選択",
                                            limitHeightItems: true,
                                            className: (InputProfileSection_module_default()).customDropdown,
                                            currentValue: stdEx.education_level_id,
                                            title: "",
                                            onChangeValue: function(val) {
                                                return handleChangeExInfo({
                                                    index: index,
                                                    attr: "education_level_id",
                                                    val: val
                                                });
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (InputProfileSection_module_default()).deleteIcon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                            name: "delete-trash",
                                            height: 24,
                                            width: 24,
                                            onClick: function() {
                                                return deleteStudyExperience(index);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (InputProfileSection_module_default()).changePositionWrapper,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (InputProfileSection_module_default()).down,
                                                children: index < studyExperiences.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                                    name: "up-position",
                                                    width: 24,
                                                    height: 24,
                                                    onClick: function() {
                                                        downPositionStudyExperience(index);
                                                    }
                                                })
                                            }),
                                            studyExperiences.length > 1 && index > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (InputProfileSection_module_default()).up,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                                    name: "up-position",
                                                    width: 24,
                                                    height: 24,
                                                    onClick: function() {
                                                        upPositionStudyExperience(index);
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (InputProfileSection_module_default()).status,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                                    title: "ステータス",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                                        items: educationStatusOptions,
                                        placeholder: "ステータスを選択",
                                        limitHeightItems: true,
                                        className: (InputProfileSection_module_default()).customDropdown,
                                        currentValue: stdEx.status,
                                        title: "",
                                        onChangeValue: function(val) {
                                            return handleChangeExInfo({
                                                index: index,
                                                attr: "status",
                                                val: val
                                            });
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (InputProfileSection_module_default()).studyTime,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                                        title: "在学期間",
                                        style: {
                                            marginRight: "10px",
                                            width: "150px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_DateInput, {
                                            date: stdEx.from ? (0,dayjs/* default */.Z)(stdEx.from).toDate() : null,
                                            setDate: function(date) {
                                                handleChangeExInfo({
                                                    index: index,
                                                    attr: "from",
                                                    val: (0,utils_user/* formatDatoToSend */.pz)(date)
                                                });
                                            },
                                            onlyMonthYear: true,
                                            showTimeSelect: false,
                                            customDateFormat: DATE_FORMAT
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "~"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                                        title: " ",
                                        style: {
                                            width: "150px",
                                            marginLeft: "10px",
                                            marginRight: "10px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_DateInput, {
                                            date: stdEx.to ? (0,dayjs/* default */.Z)(stdEx.to).toDate() : null,
                                            onlyMonthYear: true,
                                            setDate: function(date) {
                                                handleChangeExInfo({
                                                    index: index,
                                                    attr: "to",
                                                    val: (0,utils_user/* formatDatoToSend */.pz)(date)
                                                });
                                            },
                                            dateNullText: "現在",
                                            showTimeSelect: false,
                                            customDateFormat: DATE_FORMAT
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (InputProfileSection_module_default()).checkboxWrapper,
                                        onClick: function() {
                                            handleChangeExInfo({
                                                index: index,
                                                attr: "to",
                                                val: stdEx.to ? null : (0,utils_user/* formatDatoToSend */.pz)()
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "checkbox",
                                                name: "till-now-".concat(index),
                                                id: "till-now-".concat(index),
                                                readOnly: true,
                                                checked: !stdEx.to
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "現在"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (InputProfileSection_module_default()).studyExDes,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                                    title: "説明（".concat((ref1 = stdEx.description) === null || ref1 === void 0 ? void 0 : ref1.length, "/").concat(MAX_TEXT_LEN, "）"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                        value: stdEx.description,
                                        maxLength: MAX_TEXT_LEN,
                                        className: (InputProfileSection_module_default()).inputTextContent,
                                        placeholder: "例：専修大学では、経営学部に所属しておりました。組織についてや人の意思決定について興味があり、ゼミでは「組織論」や「意思決定理論」について学面と実際の組織での体験を通じて学んでおりました。 その他、スターバックスコーヒージャパンでアルバイトもしていました。時間帯責任者としてマネジメントをしたり、コーヒーに興味を持ち、お客様向けにコーヒーセミナーを開催したりしておりました。",
                                        onChange: function(e) {
                                            handleChangeExInfo({
                                                index: index,
                                                attr: "description",
                                                val: e.target.value
                                            });
                                        },
                                        style: {
                                            height: "100px"
                                        }
                                    })
                                })
                            })
                        ]
                    }, "studyEx-".concat(index));
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (InputProfileSection_module_default()).addSchool,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        text: "学校を追加",
                        onClick: function() {
                            return addBlankStudyExperience();
                        }
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (InputProfileSection_module_default()).studyExperiences,
            children: [
                (!studyExperiences || studyExperiences.length === 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (InputProfileSection_module_default()).infoShow,
                    children: BLANK_TEXT
                }),
                studyExperiences.map(function(stdEx, index) {
                    var ref, ref1;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (InputProfileSection_module_default()).studyExperience,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (InputProfileSection_module_default()).studyName,
                                children: [
                                    stdEx.school_name,
                                    " -",
                                    " ",
                                    ((ref = educationLevelsOptions === null || educationLevelsOptions === void 0 ? void 0 : educationLevelsOptions.find(function(lv) {
                                        return lv.value === stdEx.education_level_id;
                                    })) === null || ref === void 0 ? void 0 : ref.label) || BLANK_TEXT,
                                    " ",
                                    "-",
                                    " ",
                                    ((ref1 = educationStatusOptions === null || educationStatusOptions === void 0 ? void 0 : educationStatusOptions.find(function(lv) {
                                        return lv.value === stdEx.status;
                                    })) === null || ref1 === void 0 ? void 0 : ref1.label) || BLANK_TEXT
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (InputProfileSection_module_default()).studyTime,
                                children: "".concat((0,utils_user/* showDateTo */.Dr)(stdEx.from, DATE_FORMAT), " ~ ").concat((0,utils_user/* showDateTo */.Dr)(stdEx.to, DATE_FORMAT))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classnames_default()((InputProfileSection_module_default()).textContent, (InputProfileSection_module_default()).studyContent),
                                children: stdEx.description || BLANK_TEXT
                            })
                        ]
                    }, "studyEx-".concat(index));
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/modules/InputProfileSection/InputWorkExperiences/index.tsx














var InputWorkExperiences_DATE_FORMAT = "YYYY年MM月";
var InputWorkExperiences = function() {
    var ref = (0,react.useState)(false), isEditMode = ref[0], setEditMode = ref[1];
    var ref1 = (0,react.useContext)(InputProfileSectionContext), employmentTypes = ref1.employmentTypes, fetchedUserInfo = ref1.fetchedUserInfo, updateUserInfo = ref1.updateUserInfo;
    var options = (0,react.useMemo)(function() {
        return employmentTypes.map(function(type) {
            return {
                label: type.name,
                value: type.id
            };
        });
    }, [
        employmentTypes
    ]);
    var ref2 = (0,react.useState)((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.profile_jobs) || []), workExperiences = ref2[0], setWorkExperiences = ref2[1];
    (0,react.useEffect)(function() {
        if (!isEditMode) {
            setWorkExperiences((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.profile_jobs) || []);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.profile_jobs
    ]);
    var addBlankWorkExperience = function() {
        var newWorkExperiences = (0,utils/* clone */.d9)(workExperiences);
        newWorkExperiences.push({
            company_name: "",
            employment_type: "full_time",
            from: (0,utils_user/* formatDatoToSend */.pz)(),
            to: (0,utils_user/* formatDatoToSend */.pz)(),
            details: [
                {
                    department: "",
                    from: (0,utils_user/* formatDatoToSend */.pz)(),
                    to: (0,utils_user/* formatDatoToSend */.pz)(),
                    description: ""
                }, 
            ]
        });
        setWorkExperiences(newWorkExperiences);
    };
    var deleteWorkExperience = function(index) {
        var newWorkExperiences = (0,utils/* clone */.d9)(workExperiences);
        newWorkExperiences.splice(index, 1);
        setWorkExperiences(newWorkExperiences);
    };
    var changeWorkExperienceInfo = function(param) {
        var index = param.index, attr = param.attr, val = param.val;
        var newWorkExperiences = (0,utils/* clone */.d9)(workExperiences);
        if (!newWorkExperiences[index]) return;
        newWorkExperiences[index][attr] = val;
        setWorkExperiences(newWorkExperiences);
    };
    var addBlankExperience = function(wExIndex) {
        var newWorkExperiences = (0,utils/* clone */.d9)(workExperiences);
        if (!newWorkExperiences[wExIndex]) return;
        var newExs = (0,utils/* clone */.d9)(newWorkExperiences[wExIndex].details);
        newExs.push({
            department: "",
            from: (0,utils_user/* formatDatoToSend */.pz)(),
            to: (0,utils_user/* formatDatoToSend */.pz)(),
            description: ""
        });
        newWorkExperiences[wExIndex].details = newExs;
        setWorkExperiences(newWorkExperiences);
    };
    var deleteExperience = function(wExIndex, exIndex) {
        var newWorkExperiences = (0,utils/* clone */.d9)(workExperiences);
        if (!newWorkExperiences[wExIndex]) return;
        var newExs = (0,utils/* clone */.d9)(newWorkExperiences[wExIndex].details);
        newExs.splice(exIndex, 1);
        newWorkExperiences[wExIndex].details = newExs;
        setWorkExperiences(newWorkExperiences);
    };
    var changeExperienceInfo = function(param) {
        var workExpIndex = param.workExpIndex, expIndex = param.expIndex, attr = param.attr, val = param.val;
        var newWorkExperiences = (0,utils/* clone */.d9)(workExperiences);
        if (!newWorkExperiences[workExpIndex]) return;
        var newExs = (0,utils/* clone */.d9)(newWorkExperiences[workExpIndex].details);
        if (!newExs[expIndex]) return;
        newExs[expIndex][attr] = val;
        newWorkExperiences[workExpIndex].details = newExs;
        setWorkExperiences(newWorkExperiences);
    };
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var downPositionWorkExperience = function(index) {
        if (index < 0 || index >= workExperiences.length - 1) return;
        var newWorkExperiences = (0,utils/* clone */.d9)(workExperiences);
        var currentEx = newWorkExperiences[index];
        if (!currentEx) return;
        newWorkExperiences[index] = newWorkExperiences[index + 1];
        newWorkExperiences[index + 1] = currentEx;
        setWorkExperiences(newWorkExperiences);
        setSnackbarMessage({
            text: "位置を変更しました",
            type: "success"
        });
    };
    var upPositionWorkExperience = function(index) {
        if (index === 0 || index > workExperiences.length - 1) return;
        var newWorkExperiences = (0,utils/* clone */.d9)(workExperiences);
        var currentEx = newWorkExperiences[index];
        if (!currentEx) return;
        newWorkExperiences[index] = newWorkExperiences[index - 1];
        newWorkExperiences[index - 1] = currentEx;
        setWorkExperiences(newWorkExperiences);
        setSnackbarMessage({
            text: "位置を変更しました",
            type: "success"
        });
    };
    (0,react.useEffect)(function() {
        if (isEditMode && workExperiences.length === 0) {
            addBlankWorkExperience();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isEditMode
    ]);
    var hasError = (0,react.useMemo)(function() {
        return workExperiences.some(function(ex) {
            var ref;
            return !((ref = ex.company_name) === null || ref === void 0 ? void 0 : ref.trim()) || !ex.employment_type;
        });
    }, [
        workExperiences
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputInfoSubGroup, {
        name: "職歴",
        isEditMode: isEditMode,
        setEditMode: setEditMode,
        disableSave: hasError,
        errorText: hasError ? "必須項目を入力してください" : "",
        onSave: function() {
            var newsExs = workExperiences.filter(function(ex) {
                var ref;
                return !!((ref = ex.company_name) === null || ref === void 0 ? void 0 : ref.trim()) && !!ex.employment_type;
            });
            setWorkExperiences(newsExs);
            updateUserInfo({
                profile_jobs: newsExs
            });
        },
        onCancel: function() {
            setWorkExperiences((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.profile_jobs) || []);
        },
        children: isEditMode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (InputProfileSection_module_default()).workExperiencesEditMode,
            children: [
                workExperiences.map(function(wEx, WEindex) {
                    var ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (InputProfileSection_module_default()).workExperience,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (InputProfileSection_module_default()).companyName,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (InputProfileSection_module_default()).exIndex,
                                        children: [
                                            WEindex + 1,
                                            "."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                                        title: "会社名",
                                        required: true,
                                        requiredAlert: !((ref = wEx.company_name) === null || ref === void 0 ? void 0 : ref.trim()),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            name: "company_name",
                                            value: wEx.company_name,
                                            className: (InputProfileSection_module_default()).inputTextContentOneLine,
                                            placeholder: "会社名",
                                            maxLength: MAX_ONE_LINE_TEXT_LEN,
                                            onChange: function(e) {
                                                return changeWorkExperienceInfo({
                                                    index: WEindex,
                                                    attr: "company_name",
                                                    val: e.target.value
                                                });
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (InputProfileSection_module_default()).deleteIcon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                            name: "delete-trash",
                                            height: 24,
                                            width: 24,
                                            onClick: function() {
                                                return deleteWorkExperience(WEindex);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (InputProfileSection_module_default()).changePositionWrapper,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (InputProfileSection_module_default()).down,
                                                children: WEindex < workExperiences.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                                    name: "up-position",
                                                    width: 24,
                                                    height: 24,
                                                    onClick: function() {
                                                        downPositionWorkExperience(WEindex);
                                                    }
                                                })
                                            }),
                                            workExperiences.length > 1 && WEindex > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (InputProfileSection_module_default()).up,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                                    name: "up-position",
                                                    width: 24,
                                                    height: 24,
                                                    onClick: function() {
                                                        upPositionWorkExperience(WEindex);
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (InputProfileSection_module_default()).contractType,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                                    title: "契約タイプ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                                        items: options,
                                        placeholder: "契約タイプ",
                                        limitHeightItems: true,
                                        className: (InputProfileSection_module_default()).customDropdown,
                                        currentValue: wEx.employment_type,
                                        title: "",
                                        onChangeValue: function(val) {
                                            changeWorkExperienceInfo({
                                                index: WEindex,
                                                attr: "employment_type",
                                                val: val
                                            });
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (InputProfileSection_module_default()).timeInfo,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                                        title: "在籍期間",
                                        style: {
                                            marginRight: "10px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_DateInput, {
                                            date: wEx.from ? (0,dayjs/* default */.Z)(wEx.from).toDate() : null,
                                            setDate: function(date) {
                                                changeWorkExperienceInfo({
                                                    index: WEindex,
                                                    attr: "from",
                                                    val: (0,utils_user/* formatDatoToSend */.pz)(date)
                                                });
                                            },
                                            onlyMonthYear: true,
                                            showTimeSelect: false,
                                            customDateFormat: InputWorkExperiences_DATE_FORMAT
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "~"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                                        title: " ",
                                        style: {
                                            marginLeft: "10px",
                                            marginRight: "10px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_DateInput, {
                                            date: wEx.to ? (0,dayjs/* default */.Z)(wEx.to).toDate() : null,
                                            setDate: function(date) {
                                                changeWorkExperienceInfo({
                                                    index: WEindex,
                                                    attr: "to",
                                                    val: (0,utils_user/* formatDatoToSend */.pz)(date)
                                                });
                                            },
                                            onlyMonthYear: true,
                                            showTimeSelect: false,
                                            customDateFormat: InputWorkExperiences_DATE_FORMAT,
                                            dateNullText: "現在"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (InputProfileSection_module_default()).checkboxWrapper,
                                        onClick: function() {
                                            changeWorkExperienceInfo({
                                                index: WEindex,
                                                attr: "to",
                                                val: wEx.to ? null : (0,utils_user/* formatDatoToSend */.pz)()
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "checkbox",
                                                name: "till-now-".concat(WEindex),
                                                id: "till-now-".concat(WEindex),
                                                readOnly: true,
                                                checked: !wEx.to
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "現在"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (InputProfileSection_module_default()).timelineTitle,
                                children: "詳細リスト"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: (InputProfileSection_module_default()).timeline,
                                children: [
                                    (wEx.details || []).map(function(ex, index) {
                                        var ref;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: (InputProfileSection_module_default()).event,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                                                    title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (InputProfileSection_module_default()).exTitle,
                                                        children: [
                                                            "役割",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (InputProfileSection_module_default()).deleteIcon,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                                                    name: "delete-trash",
                                                                    height: 24,
                                                                    width: 24,
                                                                    onClick: function() {
                                                                        return deleteExperience(WEindex, index);
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        value: ex.department,
                                                        placeholder: "役割",
                                                        maxLength: MAX_ONE_LINE_TEXT_LEN,
                                                        onChange: function(e) {
                                                            return changeExperienceInfo({
                                                                workExpIndex: WEindex,
                                                                expIndex: index,
                                                                attr: "department",
                                                                val: e.target.value
                                                            });
                                                        },
                                                        className: (InputProfileSection_module_default()).inputTextContentOneLine
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (InputProfileSection_module_default()).dateInputGroup,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                                                            title: "在籍期間",
                                                            style: {
                                                                marginRight: "10px"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_DateInput, {
                                                                date: ex.from ? (0,dayjs/* default */.Z)(ex.from).toDate() : null,
                                                                setDate: function(date) {
                                                                    changeExperienceInfo({
                                                                        workExpIndex: WEindex,
                                                                        expIndex: index,
                                                                        attr: "from",
                                                                        val: (0,utils_user/* formatDatoToSend */.pz)(date)
                                                                    });
                                                                },
                                                                onlyMonthYear: true,
                                                                showTimeSelect: false,
                                                                customDateFormat: InputWorkExperiences_DATE_FORMAT
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "~"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                                                            title: " ",
                                                            style: {
                                                                marginLeft: "10px",
                                                                marginRight: "10px"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_DateInput, {
                                                                date: ex.to ? (0,dayjs/* default */.Z)(ex.to).toDate() : null,
                                                                setDate: function(date) {
                                                                    changeExperienceInfo({
                                                                        workExpIndex: WEindex,
                                                                        expIndex: index,
                                                                        attr: "to",
                                                                        val: (0,utils_user/* formatDatoToSend */.pz)(date)
                                                                    });
                                                                },
                                                                dateNullText: "現在",
                                                                onlyMonthYear: true,
                                                                showTimeSelect: false,
                                                                customDateFormat: InputWorkExperiences_DATE_FORMAT
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (InputProfileSection_module_default()).checkboxWrapper,
                                                            onClick: function() {
                                                                changeExperienceInfo({
                                                                    workExpIndex: WEindex,
                                                                    expIndex: index,
                                                                    attr: "to",
                                                                    val: ex.to ? null : (0,utils_user/* formatDatoToSend */.pz)()
                                                                });
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "checkbox",
                                                                    name: "till-now-".concat(WEindex, "-").concat(index),
                                                                    id: "till-now-".concat(WEindex, "-").concat(index),
                                                                    readOnly: true,
                                                                    checked: !ex.to
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "現在"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                                                    title: "説明（".concat((ref = ex.description) === null || ref === void 0 ? void 0 : ref.length, "/").concat(MAX_TEXT_LEN, "）"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                        value: ex.description,
                                                        className: (InputProfileSection_module_default()).inputTextContent,
                                                        maxLength: MAX_TEXT_LEN,
                                                        placeholder: "例：【役割】 新規営業、動画制作のディレクション、広告運用などを担当。 【営業スタイル】 ・新規営業（インバウンド50%/アウトバウンド50%) メールフォームからの営業、SNSを通じた営業、ホワイトペーパー作成 【他業務】 ・動画制作のディレクション（絵コンテ作成、フリーランス探し、ディレクション) ・広告運用のサポート（YouTube広告、Twitter広告、Facebook広告）",
                                                        onChange: function(e) {
                                                            changeExperienceInfo({
                                                                workExpIndex: WEindex,
                                                                expIndex: index,
                                                                attr: "description",
                                                                val: e.target.value
                                                            });
                                                        },
                                                        style: {
                                                            height: "100px"
                                                        }
                                                    })
                                                })
                                            ]
                                        }, "wEx-".concat(WEindex, "-").concat(index));
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (InputProfileSection_module_default()).addEx,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            text: "役割を追加",
                                            onClick: function() {
                                                return addBlankExperience(WEindex);
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    }, "wEx-".concat(WEindex));
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (InputProfileSection_module_default()).addWorkEx,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        text: "会社を追加",
                        onClick: function() {
                            return addBlankWorkExperience();
                        }
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (InputProfileSection_module_default()).workExperiences,
            children: [
                !workExperiences || workExperiences.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (InputProfileSection_module_default()).infoShow,
                    children: BLANK_TEXT
                }),
                (workExperiences || []).map(function(wEx, WEindex) {
                    var ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (InputProfileSection_module_default()).workExperience,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (InputProfileSection_module_default()).companyName,
                                children: wEx.company_name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (InputProfileSection_module_default()).timeInfo,
                                children: [
                                    (ref = options.find(function(op) {
                                        return op.value === wEx.employment_type;
                                    })) === null || ref === void 0 ? void 0 : ref.label,
                                    " ",
                                    "".concat((0,utils_user/* showDateTo */.Dr)(wEx.from, InputWorkExperiences_DATE_FORMAT), " ~\n                  ").concat((0,utils_user/* showDateTo */.Dr)(wEx.to, InputWorkExperiences_DATE_FORMAT))
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: (InputProfileSection_module_default()).timeline,
                                children: (wEx.details || []).map(function(ex, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: (InputProfileSection_module_default()).event,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (InputProfileSection_module_default()).department,
                                                children: ex.department || BLANK_TEXT
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (InputProfileSection_module_default()).dateRange,
                                                children: "".concat((0,utils_user/* showDateTo */.Dr)(ex.from, InputWorkExperiences_DATE_FORMAT), " ~\n                          ").concat((0,utils_user/* showDateTo */.Dr)(ex.to, InputWorkExperiences_DATE_FORMAT))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (InputProfileSection_module_default()).textContent,
                                                children: ex.description || BLANK_TEXT
                                            })
                                        ]
                                    }, "wEx-".concat(WEindex, "-").concat(index));
                                })
                            })
                        ]
                    }, "wEx-".concat(WEindex));
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/modules/InputProfileSection/InputAddress/index.tsx







// import classNames from 'classnames';






var InputAddress = function() {
    var ref = (0,react.useState)(false), isEditMode = ref[0], setEditMode = ref[1];
    var ref1 = (0,react.useContext)(InputProfileSectionContext), fetchedUserInfo = ref1.fetchedUserInfo, updateUserInfo = ref1.updateUserInfo;
    var ref2 = (0,react.useState)({
        zip_1: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_zip1) || "",
        zip_2: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_zip2) || "",
        kenName: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_prefecture) || "",
        cityName: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_city) || "",
        townName: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_street) || "",
        roomInfo: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_building_room) || ""
    }), addressObject = ref2[0], setAddressObject = ref2[1];
    var addressText = (0,react.useMemo)(function() {
        if (!addressObject.zip_1 && !addressObject.zip_2 && !addressObject.kenName && !addressObject.cityName && !addressObject.townName && !addressObject.roomInfo) return "";
        var line1 = addressObject.zip_1 || addressObject.zip_2 ? "〒".concat("".concat(addressObject.zip_1 || "", " - ")).concat(addressObject.zip_2 || "", "\n") : "";
        return "".concat(line1).concat(addressObject.kenName || "", " ").concat(addressObject.cityName || "", " ").concat(addressObject.townName || "", " ").concat(addressObject.roomInfo || "");
    }, [
        addressObject
    ]);
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    (0,react.useEffect)(function() {
        if (!isEditMode) {
            setAddressObject({
                zip_1: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_zip1) || "",
                zip_2: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_zip2) || "",
                kenName: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_prefecture) || "",
                cityName: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_city) || "",
                townName: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_street) || "",
                roomInfo: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_building_room) || ""
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_building_room,
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_city,
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_prefecture,
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_street,
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_zip1,
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_zip2, 
    ]);
    var ref3 = (0,es.useMutation)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var zip;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    zip = "".concat(addressObject.zip_1, "-").concat(addressObject.zip_2);
                    _ctx.next = 3;
                    return (0,user/* getAddressByZip */.KW)(zip);
                case 3:
                    return _ctx.abrupt("return", _ctx.sent);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        onSuccess: function(data) {
            var result = data.data;
            var newAddress = (0,utils/* clone */.d9)(addressObject);
            newAddress.kenName = result.ken_name;
            newAddress.cityName = result.city_name;
            newAddress.townName = result.town_name;
            setAddressObject(newAddress);
        },
        onError: function() {
            setSnackbarMessage({
                type: "error",
                text: "入力された郵便番号から住所を見つけられませんでした"
            });
        }
    }), searchAddress = ref3.mutate, isSearchingAddress = ref3.isLoading;
    var handleChangeAddress = function(e, type) {
        var value = e.target.value;
        var newAddressObject = (0,utils/* clone */.d9)(addressObject);
        newAddressObject[type] = value;
        setAddressObject(newAddressObject);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputInfoSubGroup, {
        name: "住所",
        isEditMode: isEditMode,
        setEditMode: setEditMode,
        onSave: function() {
            updateUserInfo({
                address_zip1: addressObject === null || addressObject === void 0 ? void 0 : addressObject.zip_1,
                address_zip2: addressObject === null || addressObject === void 0 ? void 0 : addressObject.zip_2,
                address_prefecture: addressObject === null || addressObject === void 0 ? void 0 : addressObject.kenName,
                address_city: addressObject === null || addressObject === void 0 ? void 0 : addressObject.cityName,
                address_street: addressObject === null || addressObject === void 0 ? void 0 : addressObject.townName,
                address_building_room: addressObject === null || addressObject === void 0 ? void 0 : addressObject.roomInfo
            });
        },
        onCancel: function() {
            setAddressObject({
                zip_1: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_zip1) || "",
                zip_2: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_zip2) || "",
                kenName: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_prefecture) || "",
                cityName: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_city) || "",
                townName: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_street) || "",
                roomInfo: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.address_building_room) || ""
            });
        },
        children: isEditMode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (InputProfileSection_module_default()).inputAdressEditMode,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (InputProfileSection_module_default()).addressInputGroup,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                            style: {
                                width: "110px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                placeholder: "郵便番号",
                                type: "text",
                                name: "zip_1",
                                value: addressObject.zip_1,
                                maxLength: 3,
                                onChange: function(e) {
                                    return handleChangeAddress(e, "zip_1");
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (InputProfileSection_module_default()).devide,
                            children: "-"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                            style: {
                                width: "110px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                placeholder: "郵便番号",
                                type: "text",
                                name: "zip_2",
                                value: addressObject.zip_2,
                                maxLength: 4,
                                onChange: function(e) {
                                    return handleChangeAddress(e, "zip_2");
                                }
                            })
                        }),
                        isSearchingAddress ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (InputProfileSection_module_default()).searchBtn,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                name: "loading-anim-3",
                                width: 24,
                                height: 24
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (InputProfileSection_module_default()).searchBtn,
                            onClick: function() {
                                if (!addressObject.zip_1 || !addressObject.zip_2) {
                                    setSnackbarMessage({
                                        type: "error",
                                        text: "郵便番号を入力してください"
                                    });
                                    return;
                                }
                                searchAddress();
                            },
                            children: "検索"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (InputProfileSection_module_default()).addressInputGroup,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                            style: {
                                width: "150px",
                                marginRight: "10px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                placeholder: "都道府県",
                                name: "kenName",
                                type: "text",
                                value: addressObject.kenName,
                                maxLength: MAX_ONE_LINE_TEXT_LEN,
                                onChange: function(e) {
                                    return handleChangeAddress(e, "kenName");
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                            style: {
                                width: "150px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                placeholder: "市区町村",
                                name: "cityName",
                                type: "text",
                                value: addressObject.cityName,
                                maxLength: MAX_ONE_LINE_TEXT_LEN,
                                onChange: function(e) {
                                    return handleChangeAddress(e, "cityName");
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (InputProfileSection_module_default()).addressInputGroup,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                        style: {
                            width: "310px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            placeholder: "番地以降",
                            value: addressObject.townName,
                            name: "townName",
                            type: "text",
                            maxLength: MAX_ONE_LINE_TEXT_LEN,
                            onChange: function(e) {
                                return handleChangeAddress(e, "townName");
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (InputProfileSection_module_default()).addressInputGroup,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                        style: {
                            width: "310px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            placeholder: "建物名・部屋番号",
                            name: "roomInfo",
                            type: "text",
                            value: addressObject.roomInfo,
                            maxLength: MAX_ONE_LINE_TEXT_LEN,
                            onChange: function(e) {
                                return handleChangeAddress(e, "roomInfo");
                            }
                        })
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (InputProfileSection_module_default()).infoShow,
            children: addressText || BLANK_TEXT
        })
    });
};
/* harmony default export */ var InputProfileSection_InputAddress = (InputAddress);

;// CONCATENATED MODULE: ./components/modules/InputProfileSection/InputName/index.tsx







var InputName = function() {
    var ref = (0,react.useContext)(InputProfileSectionContext), fetchedUserInfo = ref.fetchedUserInfo, updateUserInfo = ref.updateUserInfo;
    var ref1 = (0,react.useState)(false), isEditMode = ref1[0], setEditMode = ref1[1];
    var ref2 = (0,react.useState)({
        firstName: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.first_name) || "",
        firstNameKana: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.first_name_kana) || "",
        lastName: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.last_name) || "",
        lastNameKana: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.last_name_kana) || ""
    }), nameObject = ref2[0], setNameObject = ref2[1];
    var fullNameText = (0,react.useMemo)(function() {
        if (!nameObject.firstName && !nameObject.lastName) return "";
        return "".concat(nameObject.firstName || "", " ").concat(nameObject.lastName || "");
    }, [
        nameObject
    ]);
    var fullNameTextKana = (0,react.useMemo)(function() {
        if (!nameObject.firstNameKana && !nameObject.lastNameKana) return "";
        return "".concat(nameObject.firstNameKana || "", " ").concat(nameObject.lastNameKana || "");
    }, [
        nameObject
    ]);
    (0,react.useEffect)(function() {
        if (!isEditMode) {
            setNameObject({
                firstName: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.first_name) || "",
                firstNameKana: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.first_name_kana) || "",
                lastName: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.last_name) || "",
                lastNameKana: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.last_name_kana) || ""
            });
        }
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.first_name,
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.first_name_kana,
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.last_name,
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.last_name_kana,
        isEditMode, 
    ]);
    var handleChange = function(e, type) {
        var value = e.target.value;
        var newObject = (0,utils/* clone */.d9)(nameObject);
        newObject[type] = value;
        setNameObject(newObject);
    };
    var firstNameKanaError = !(0,utils/* kanaValid */._J)(nameObject === null || nameObject === void 0 ? void 0 : nameObject.firstNameKana);
    var lastNameKanaError = !(0,utils/* kanaValid */._J)(nameObject === null || nameObject === void 0 ? void 0 : nameObject.lastNameKana);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputInfoSubGroup, {
        name: "名前",
        isEditMode: isEditMode,
        setEditMode: setEditMode,
        disableSave: firstNameKanaError || lastNameKanaError,
        onSave: function() {
            updateUserInfo({
                first_name: nameObject.firstName,
                first_name_kana: nameObject.firstNameKana,
                last_name: nameObject.lastName,
                last_name_kana: nameObject.lastNameKana
            });
        },
        onCancel: function() {
            setNameObject({
                firstName: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.first_name) || "",
                firstNameKana: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.first_name_kana) || "",
                lastName: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.last_name) || "",
                lastNameKana: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.last_name_kana) || ""
            });
        },
        children: isEditMode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (InputProfileSection_module_default()).inputNameEditMode,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (InputProfileSection_module_default()).nameInputGroup,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                            style: {
                                width: "160px",
                                marginRight: "10px"
                            },
                            title: "姓",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                placeholder: "姓",
                                type: "text",
                                name: "first_name",
                                maxLength: MAX_ONE_LINE_TEXT_LEN,
                                value: nameObject.firstName,
                                onChange: function(e) {
                                    return handleChange(e, "firstName");
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                            style: {
                                width: "160px"
                            },
                            title: "名",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                placeholder: "名",
                                type: "text",
                                name: "last_name",
                                maxLength: MAX_ONE_LINE_TEXT_LEN,
                                value: nameObject.lastName,
                                onChange: function(e) {
                                    return handleChange(e, "lastName");
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (InputProfileSection_module_default()).nameInputGroup,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                            style: {
                                width: "160px",
                                marginRight: "10px"
                            },
                            error: firstNameKanaError ? "全角カナで入力してください" : "",
                            title: "姓(カタカナ)",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                placeholder: "姓(カタカナ)",
                                value: nameObject.firstNameKana,
                                name: "first_name_kana",
                                type: "text",
                                maxLength: MAX_ONE_LINE_TEXT_LEN,
                                onChange: function(e) {
                                    return handleChange(e, "firstNameKana");
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
                            style: {
                                width: "160px"
                            },
                            error: lastNameKanaError ? "全角カナで入力してください" : "",
                            title: "名(カタカナ)",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                placeholder: "名(カタカナ)",
                                name: "last_name_kana",
                                type: "text",
                                value: nameObject.lastNameKana,
                                maxLength: MAX_ONE_LINE_TEXT_LEN,
                                onChange: function(e) {
                                    return handleChange(e, "lastNameKana");
                                }
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (InputProfileSection_module_default()).infoShow,
            children: [
                fullNameText && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: fullNameText
                }),
                fullNameTextKana && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    style: {
                        marginTop: "5px"
                    },
                    children: fullNameTextKana
                }),
                !fullNameText && !fullNameTextKana && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: BLANK_TEXT
                })
            ]
        })
    });
};
/* harmony default export */ var InputProfileSection_InputName = (InputName);

// EXTERNAL MODULE: ./node_modules/@amplitude/analytics-browser/lib/esm/index.js + 159 modules
var lib_esm = __webpack_require__(65972);
;// CONCATENATED MODULE: ./components/modules/InputProfileSection/Content/index.tsx























var MAX_TEXT_LEN = 2000;
var MAX_ONE_LINE_TEXT_LEN = 100;
var BLANK_TEXT = "未入力";
var maxLengthError = function(maxLength) {
    return "".concat(maxLength, "文字以内で入力してください");
};
var InputInfoGroup = function(param) {
    var id = param.id, tooltipContent = param.tooltipContent, name = param.name, children = param.children, _disablePublic = param.disablePublic, disablePublic = _disablePublic === void 0 ? false : _disablePublic, _isPublic = param.isPublic, isPublic = _isPublic === void 0 ? false : _isPublic, setIsPublic = param.setIsPublic;
    var ref = (0,react.useContext)(InputProfileSectionContext), onlyViewMode = ref.onlyViewMode, updateUserInfo = ref.updateUserInfo;
    if (onlyViewMode && !isPublic) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (InputProfileSection_module_default()).inputInfoGroup,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (InputProfileSection_module_default()).groupHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (InputProfileSection_module_default()).groupName,
                        children: name
                    }),
                    !onlyViewMode && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: !disablePublic ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (InputProfileSection_module_default()).rightSide,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpPopover/* default */.Z, {
                                    tooltipClassname: (InputProfileSection_module_default()).tooltip,
                                    tooltipWidth: 220,
                                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: tooltipContent
                                    }),
                                    className: (InputProfileSection_module_default()).publicHelpIcon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSwitch/* default */.Z, {
                                    enable: isPublic,
                                    handleChange: function(publicS) {
                                        if (disablePublic) return;
                                        updateUserInfo((0,_define_property/* default */.Z)({}, id, publicS));
                                        setIsPublic(publicS);
                                    },
                                    titleOff: "公開",
                                    titleOn: "公開",
                                    id: "".concat(id, "-publicSetting")
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (InputProfileSection_module_default()).warningText,
                            children: "ご本人以外には公開されません"
                        })
                    })
                ]
            }),
            children
        ]
    });
};
var InputInfoSubGroup = function(param) {
    var name = param.name, children = param.children, isEditMode = param.isEditMode, setEditMode = param.setEditMode, onCancel = param.onCancel, onSave = param.onSave, _disableSave = param.disableSave, disableSave = _disableSave === void 0 ? false : _disableSave, _highlightName = param.highlightName, highlightName = _highlightName === void 0 ? false : _highlightName, _errorText = param.errorText, errorText = _errorText === void 0 ? "" : _errorText;
    var ref = (0,react.useContext)(InputProfileSectionContext), onlyViewMode = ref.onlyViewMode, isFetchingData = ref.isFetchingData, isUpdating = ref.isUpdating, setEditingProfileCount = ref.setEditingProfileCount;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((InputProfileSection_module_default()).inputInfoSubGroup, (0,_define_property/* default */.Z)({}, (InputProfileSection_module_default()).editMode, isEditMode)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (InputProfileSection_module_default()).subGroupHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((InputProfileSection_module_default()).subGroupName, (0,_define_property/* default */.Z)({}, (InputProfileSection_module_default()).highlightName, highlightName)),
                        children: name
                    }),
                    !onlyViewMode && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: isEditMode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (InputProfileSection_module_default()).rightSide,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    text: "キャンセル",
                                    blackAndWhite: true,
                                    onClick: function() {
                                        setEditMode && setEditMode(false);
                                        setEditingProfileCount(function(count) {
                                            return count - 1;
                                        });
                                        onCancel && onCancel();
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    text: "保存",
                                    disabled: !!disableSave || isUpdating || isFetchingData,
                                    onClick: function() {
                                        setEditMode && setEditMode(false);
                                        setEditingProfileCount(function(count) {
                                            return count - 1;
                                        });
                                        (0,lib_esm/* track */.j)("Complete Enter Profile", {
                                            profile_item_name: name
                                        });
                                        onSave && onSave();
                                    }
                                }),
                                errorText && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (InputProfileSection_module_default()).errorMessenge,
                                    children: errorText
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (InputProfileSection_module_default()).rightSide,
                            style: isUpdating || isFetchingData ? {
                                opacity: 0.5,
                                pointerEvents: "none"
                            } : {},
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                name: "edit-black",
                                height: 22,
                                width: 22,
                                onClick: function() {
                                    if (isUpdating || isFetchingData) return;
                                    setEditMode && setEditMode(true);
                                    setEditingProfileCount(function(count) {
                                        return count + 1;
                                    });
                                }
                            })
                        })
                    })
                ]
            }),
            children
        ]
    });
};
var InputIntro = function() {
    var ref = (0,react.useContext)(InputProfileSectionContext), fetchedUserInfo = ref.fetchedUserInfo, updateUserInfo = ref.updateUserInfo;
    var ref1 = (0,react.useState)(false), isEditMode = ref1[0], setEditMode = ref1[1];
    var ref2 = (0,react.useState)((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.self_introduction) || ""), introText = ref2[0], setIntroText = ref2[1];
    (0,react.useEffect)(function() {
        if (!isEditMode) {
            setIntroText((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.self_introduction) || "");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.self_introduction
    ]);
    var hasErrorMaxLength = introText.length > MAX_TEXT_LEN;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputInfoSubGroup, {
        name: "自己紹介",
        isEditMode: isEditMode,
        setEditMode: setEditMode,
        onSave: function() {
            updateUserInfo({
                self_introduction: introText
            });
        },
        onCancel: function() {
            setIntroText((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.self_introduction) || "");
        },
        disableSave: hasErrorMaxLength,
        children: isEditMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
            title: "".concat(introText.length, "/").concat(MAX_TEXT_LEN),
            error: hasErrorMaxLength ? maxLengthError(MAX_TEXT_LEN) : "",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                className: (InputProfileSection_module_default()).inputTextContent,
                rows: 5,
                placeholder: "例：PostPrimeの人材紹介立ち上げをしています。 日本の雇用をもっと自由に選択できる世界を目指しています。 その他に人事関連や営業関連について活動を行ったり、学んだりもしています。",
                value: introText,
                maxLength: MAX_TEXT_LEN,
                onChange: function(e) {
                    return setIntroText(e.target.value);
                }
            })
        }) : introText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (InputProfileSection_module_default()).textContent,
            children: introText
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (InputProfileSection_module_default()).infoShow,
            children: BLANK_TEXT
        })
    });
};
// export const InputActivity = () => {
//   const { fetchedUserInfo } = useContext(InputProfileSectionContext);
//   const [isEditMode, setEditMode] = useState(false);
//   const [activityText, setActivityText] = useState(
//     fetchedUserInfo?.activity || ''
//   );
//   useEffect(() => {
//     if (!isEditMode) {
//       setActivityText(fetchedUserInfo?.activity || '');
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [fetchedUserInfo?.activity]);
//   const hasErrorMaxLength = activityText.length > MAX_TEXT_LEN;
//   return (
//     <InputInfoSubGroup
//       name="活動・コミュニティ"
//       isEditMode={isEditMode}
//       setEditMode={setEditMode}
//       disableSave={hasErrorMaxLength}
//     >
//       {isEditMode ? (
//         <InputWithLabel
//           title={`${activityText.length}/${MAX_TEXT_LEN}`}
//           error={hasErrorMaxLength ? maxLengthError(MAX_TEXT_LEN) : ''}
//         >
//           <textarea
//             className={styles.inputTextContent}
//             rows={5}
//             placeholder="活動・コミュニティを記入してください"
//             value={activityText}
//             onChange={(e) => setActivityText(e.target.value)}
//           />
//         </InputWithLabel>
//       ) : (
//         <div className={styles.textContent}>{activityText || BLANK_TEXT}</div>
//       )}
//     </InputInfoSubGroup>
//   );
// };
var InputPhoneNumber = function() {
    var ref = (0,react.useContext)(InputProfileSectionContext), fetchedUserInfo = ref.fetchedUserInfo, updateUserInfo = ref.updateUserInfo;
    var ref1 = (0,react.useState)(false), isEditMode = ref1[0], setEditMode = ref1[1];
    var ref2 = (0,react.useState)((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.phone_number) || ""), phoneNumber = ref2[0], setPhoneNumber = ref2[1];
    (0,react.useEffect)(function() {
        if (!isEditMode) {
            setPhoneNumber((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.phone_number) || "");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.phone_number
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputInfoSubGroup, {
        name: "電話番号",
        isEditMode: isEditMode,
        setEditMode: setEditMode,
        onSave: function() {
            updateUserInfo({
                phone_number: phoneNumber
            });
        },
        onCancel: function() {
            setPhoneNumber((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.phone_number) || "");
        },
        children: isEditMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
            title: "".concat(phoneNumber.length, "/").concat(MAX_ONE_LINE_TEXT_LEN),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                className: (InputProfileSection_module_default()).inputTextContentOneLine,
                placeholder: "例：080 8888 8888",
                value: phoneNumber,
                name: "phone_number",
                maxLength: MAX_ONE_LINE_TEXT_LEN,
                onChange: function(e) {
                    var newVal = e.target.value;
                    // if (newVal.length > MAX_ONE_LINE_TEXT_LEN) return;
                    setPhoneNumber(newVal);
                }
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (InputProfileSection_module_default()).infoShow,
            children: phoneNumber ? "********".concat(phoneNumber.substring(phoneNumber.length - 4)) : BLANK_TEXT
        })
    });
};
var InputContactEmail = function() {
    var ref = (0,react.useContext)(InputProfileSectionContext), fetchedUserInfo = ref.fetchedUserInfo, updateUserInfo = ref.updateUserInfo;
    var ref1 = (0,react.useState)(false), isEditMode = ref1[0], setEditMode = ref1[1];
    var ref2 = (0,react.useState)((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.email) || ""), contactEmail = ref2[0], setContactEmail = ref2[1];
    var hasErrorEmail = contactEmail && !(0,utils/* validEmail */.u$)(contactEmail);
    (0,react.useEffect)(function() {
        if (!isEditMode) {
            setContactEmail((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.email) || "");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.email
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputInfoSubGroup, {
        name: "連絡メールアドレス",
        isEditMode: isEditMode,
        setEditMode: setEditMode,
        disableSave: hasErrorEmail,
        onSave: function() {
            updateUserInfo({
                email: contactEmail
            });
        },
        onCancel: function() {
            setContactEmail((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.email) || "");
        },
        children: isEditMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
            title: "".concat(contactEmail.length, "/").concat(MAX_ONE_LINE_TEXT_LEN),
            error: hasErrorEmail ? "正しいメールアドレスをご入力ください" : "",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                className: (InputProfileSection_module_default()).inputTextContentOneLine,
                placeholder: "連絡メールアドレスを入力する",
                maxLength: MAX_ONE_LINE_TEXT_LEN,
                value: contactEmail,
                type: "email",
                name: "email",
                onChange: function(e) {
                    var newVal = e.target.value.replace(/ /g, "").replace(/\s/g, "");
                    // if (newVal.length > MAX_ONE_LINE_TEXT_LEN) return;
                    setContactEmail(newVal);
                }
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (InputProfileSection_module_default()).infoShow,
            children: contactEmail || BLANK_TEXT
        })
    });
};
var InputHobbie = function() {
    var ref = (0,react.useContext)(InputProfileSectionContext), fetchedUserInfo = ref.fetchedUserInfo, updateUserInfo = ref.updateUserInfo;
    var ref1 = (0,react.useState)(false), isEditMode = ref1[0], setEditMode = ref1[1];
    var ref2 = (0,react.useState)((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.interest) || ""), hobbieText = ref2[0], setHobbieText = ref2[1];
    var hasErrorMaxLength = hobbieText.length > MAX_TEXT_LEN;
    (0,react.useEffect)(function() {
        if (!isEditMode) {
            setHobbieText((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.interest) || "");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.interest
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputInfoSubGroup, {
        name: "興味・希望",
        isEditMode: isEditMode,
        setEditMode: setEditMode,
        disableSave: hasErrorMaxLength,
        onSave: function() {
            updateUserInfo({
                interest: hobbieText
            });
        },
        onCancel: function() {
            setHobbieText((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.interest) || "");
        },
        children: isEditMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
            title: "".concat(hobbieText.length, "/").concat(MAX_TEXT_LEN),
            error: hasErrorMaxLength ? maxLengthError(MAX_TEXT_LEN) : "",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                className: (InputProfileSection_module_default()).inputTextContent,
                rows: 5,
                placeholder: "例：社会にとって良いと思うサービスの支援 これまでの経験を活かし、携わるサービスや企業の成功支援することに取り組みたいです。 事業に関する知見やスキルを深めていく 自身の課題として事業理解がまだまだ乏しいことが挙げられると考えております。 今後は上記経験を伸ばし、影響を高めていきたいです。",
                value: hobbieText,
                maxLength: MAX_TEXT_LEN,
                onChange: function(e) {
                    return setHobbieText(e.target.value);
                }
            })
        }) : hobbieText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (InputProfileSection_module_default()).textContent,
            children: hobbieText
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (InputProfileSection_module_default()).infoShow,
            children: BLANK_TEXT
        })
    });
};
var InputIncome = function() {
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), isEditMode = ref3[0], setEditMode = ref3[1];
    var ref4 = (0,react.useContext)(InputProfileSectionContext), salaryRanges = ref4.salaryRanges, fetchedUserInfo = ref4.fetchedUserInfo, updateUserInfo = ref4.updateUserInfo;
    var options = (0,react.useMemo)(function() {
        return salaryRanges.map(function(range) {
            return {
                label: range.name,
                value: range.id
            };
        });
    }, [
        salaryRanges
    ]);
    var ref5 = (0,react.useState)(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.current_salary_range) === null || ref === void 0 ? void 0 : ref.id), currentSalaryId = ref5[0], setCurrentSalaryId = ref5[1];
    (0,react.useEffect)(function() {
        if (!isEditMode) {
            var ref;
            setCurrentSalaryId(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.current_salary_range) === null || ref === void 0 ? void 0 : ref.id);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref1 = fetchedUserInfo.current_salary_range) === null || ref1 === void 0 ? void 0 : ref1.id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputInfoSubGroup, {
        name: "現在の年収",
        isEditMode: isEditMode,
        setEditMode: setEditMode,
        onSave: function() {
            updateUserInfo({
                current_salary_range_id: currentSalaryId || 0
            });
        },
        onCancel: function() {
            var ref;
            setCurrentSalaryId(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.current_salary_range) === null || ref === void 0 ? void 0 : ref.id);
        },
        children: isEditMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(common_DropdownWithSearch, {
            items: options,
            placeholder: "現在の年収",
            limitHeightItems: true,
            className: (InputProfileSection_module_default()).customDropdown,
            currentValue: currentSalaryId,
            title: "",
            onChangeValue: function(val) {
                return setCurrentSalaryId(val);
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (InputProfileSection_module_default()).infoShow,
            children: ((ref2 = options.find(function(op) {
                return op.value === currentSalaryId;
            })) === null || ref2 === void 0 ? void 0 : ref2.label) || BLANK_TEXT
        })
    });
};
var InputDesiredIncome = function() {
    var ref, ref1, ref2;
    var ref3 = (0,react.useContext)(InputProfileSectionContext), salaryRanges = ref3.salaryRanges, fetchedUserInfo = ref3.fetchedUserInfo, updateUserInfo = ref3.updateUserInfo;
    var options = (0,react.useMemo)(function() {
        return salaryRanges.map(function(range) {
            return {
                label: range.name,
                value: range.id
            };
        });
    }, [
        salaryRanges
    ]);
    var ref4 = (0,react.useState)(false), isEditMode = ref4[0], setEditMode = ref4[1];
    var ref5 = (0,react.useState)(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.desired_salary_range) === null || ref === void 0 ? void 0 : ref.id), desiredSalaryId = ref5[0], setDesiredSalaryId = ref5[1];
    (0,react.useEffect)(function() {
        if (!isEditMode) {
            var ref;
            setDesiredSalaryId(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.desired_salary_range) === null || ref === void 0 ? void 0 : ref.id);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref1 = fetchedUserInfo.desired_salary_range) === null || ref1 === void 0 ? void 0 : ref1.id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputInfoSubGroup, {
        name: "希望の年収",
        isEditMode: isEditMode,
        setEditMode: setEditMode,
        onSave: function() {
            updateUserInfo({
                desired_salary_range_id: desiredSalaryId || 0
            });
        },
        onCancel: function() {
            var ref;
            setDesiredSalaryId(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.desired_salary_range) === null || ref === void 0 ? void 0 : ref.id);
        },
        children: isEditMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(common_DropdownWithSearch, {
            items: options,
            placeholder: "希望の年収",
            limitHeightItems: true,
            className: (InputProfileSection_module_default()).customDropdown,
            currentValue: desiredSalaryId,
            title: "",
            onChangeValue: function(val) {
                return setDesiredSalaryId(val);
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (InputProfileSection_module_default()).infoShow,
            children: ((ref2 = options.find(function(op) {
                return op.value === desiredSalaryId;
            })) === null || ref2 === void 0 ? void 0 : ref2.label) || BLANK_TEXT
        })
    });
};
var InputCountry = function() {
    var ref, ref1, ref2;
    var ref3 = (0,react.useContext)(InputProfileSectionContext), nationalities = ref3.nationalities, fetchedUserInfo = ref3.fetchedUserInfo, updateUserInfo = ref3.updateUserInfo;
    var options = (0,react.useMemo)(function() {
        return nationalities.map(function(nation) {
            return {
                label: nation.name,
                value: nation.id
            };
        });
    }, [
        nationalities
    ]);
    var ref4 = (0,react.useState)(false), isEditMode = ref4[0], setEditMode = ref4[1];
    var ref5 = (0,react.useState)(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.nationality) === null || ref === void 0 ? void 0 : ref.id), countryId = ref5[0], setCountryId = ref5[1];
    (0,react.useEffect)(function() {
        if (!isEditMode) {
            var ref;
            setCountryId(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.nationality) === null || ref === void 0 ? void 0 : ref.id);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref1 = fetchedUserInfo.nationality) === null || ref1 === void 0 ? void 0 : ref1.id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputInfoSubGroup, {
        name: "国籍",
        isEditMode: isEditMode,
        setEditMode: setEditMode,
        onSave: function() {
            updateUserInfo({
                nationality_id: countryId || 0
            });
        },
        onCancel: function() {
            var ref;
            setCountryId(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.nationality) === null || ref === void 0 ? void 0 : ref.id);
        },
        children: isEditMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(common_DropdownWithSearch, {
            items: options,
            placeholder: "国籍を検索する",
            limitHeightItems: true,
            className: (InputProfileSection_module_default()).customDropdown,
            currentValue: countryId,
            title: "",
            onChangeValue: function(val) {
                return setCountryId(val);
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (InputProfileSection_module_default()).infoShow,
            children: (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref2 = fetchedUserInfo.nationality) === null || ref2 === void 0 ? void 0 : ref2.name) || BLANK_TEXT
        })
    });
};
var InputDateOfBirth = function() {
    var ref = (0,react.useState)(false), isEditMode = ref[0], setEditMode = ref[1];
    var ref1 = (0,react.useContext)(InputProfileSectionContext), fetchedUserInfo = ref1.fetchedUserInfo, updateUserInfo = ref1.updateUserInfo;
    var ref2 = (0,react.useState)((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.birthday) ? new Date(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.birthday) : null), birthDay = ref2[0], setBirthDay = ref2[1];
    (0,react.useEffect)(function() {
        if (!isEditMode) {
            setBirthDay((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.birthday) ? new Date(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.birthday) : null);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.birthday
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputInfoSubGroup, {
        name: "生年月日",
        isEditMode: isEditMode,
        setEditMode: setEditMode,
        onSave: function() {
            updateUserInfo({
                birthday: birthDay ? (0,dayjs/* default */.Z)(birthDay).format("YYYY-MM-DD") : ""
            });
        },
        onCancel: function() {
            setBirthDay((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.birthday) ? new Date(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.birthday) : null);
        },
        children: isEditMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabelV2/* default */.Z, {
            style: {
                width: "200px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_DateInput, {
                date: birthDay,
                showTimeSelect: false,
                setDate: function(date) {
                    return setBirthDay(date);
                },
                dateNullText: "生年月日を入力する",
                resetSupport: true
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (InputProfileSection_module_default()).infoShow,
            children: birthDay ? (0,dayjs/* default */.Z)(birthDay).format("YYYY/MM/DD") : BLANK_TEXT
        })
    });
};
var InputGender = function() {
    var ref;
    var ref1 = (0,react.useContext)(InputProfileSectionContext), fetchedUserInfo = ref1.fetchedUserInfo, updateUserInfo = ref1.updateUserInfo;
    var options = (0,react.useMemo)(function() {
        return [
            {
                value: 0,
                label: "未回答"
            },
            {
                value: 1,
                label: "男性"
            },
            {
                value: 2,
                label: "女性"
            }, 
        ];
    }, []);
    var ref2 = (0,react.useState)(false), isEditMode = ref2[0], setEditMode = ref2[1];
    var ref3 = (0,react.useState)((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.gender) || 0), gender = ref3[0], setGender = ref3[1];
    (0,react.useEffect)(function() {
        if (!isEditMode) {
            setGender(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.gender);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.gender
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputInfoSubGroup, {
        name: "性別",
        isEditMode: isEditMode,
        setEditMode: setEditMode,
        onSave: function() {
            updateUserInfo({
                gender: gender
            });
        },
        onCancel: function() {
            setGender(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.gender);
        },
        children: isEditMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
            items: options,
            placeholder: "性別",
            limitHeightItems: true,
            className: (InputProfileSection_module_default()).customDropdown,
            currentValue: gender,
            title: "",
            onChangeValue: function(val) {
                return setGender(val);
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (InputProfileSection_module_default()).infoShow,
            children: ((ref = options.find(function(op) {
                return op.value === gender;
            })) === null || ref === void 0 ? void 0 : ref.label) || "未回答"
        })
    });
};
var ProfileSection = function() {
    var fetchedUserInfo = (0,react.useContext)(InputProfileSectionContext).fetchedUserInfo;
    var ref = (0,react.useState)((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.is_profile_public) || false), isPublic = ref[0], setIsPublic = ref[1];
    (0,react.useEffect)(function() {
        setIsPublic((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.is_profile_public) || false);
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.is_profile_public
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputInfoGroup, {
        id: "is_profile_public",
        name: "プロフィール",
        tooltipContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                "公開してからご本人以外の方からも",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                " 見られるようになります。"
            ]
        }),
        isPublic: isPublic,
        setIsPublic: setIsPublic,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputIntro, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLanguages, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputSkills, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputHobbie, {})
        ]
    });
};
var BasicInfoSection = function() {
    var fetchedUserInfo = (0,react.useContext)(InputProfileSectionContext).fetchedUserInfo;
    var ref = (0,react.useState)((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.is_basic_information_public) || false), isPublic = ref[0], setIsPublic = ref[1];
    (0,react.useEffect)(function() {
        setIsPublic((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.is_basic_information_public) || false);
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.is_basic_information_public
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputInfoGroup, {
        id: "is_basic_information_public",
        name: "基本情報",
        tooltipContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                "公開してからご本人以外の方からも",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                " 見られるようになります。"
            ]
        }),
        isPublic: isPublic,
        setIsPublic: setIsPublic,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputProfileSection_InputName, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputCountry, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputDateOfBirth, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputGender, {})
        ]
    });
};
var InputIndustryType = function() {
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), isEditMode = ref3[0], setEditMode = ref3[1];
    var ref4 = (0,react.useContext)(InputProfileSectionContext), industryTypes = ref4.industryTypes, updateUserInfo = ref4.updateUserInfo, fetchedUserInfo = ref4.fetchedUserInfo;
    var options = (0,react.useMemo)(function() {
        return industryTypes.map(function(type) {
            return {
                label: type.name,
                value: type.id
            };
        });
    }, [
        industryTypes
    ]);
    var ref5 = (0,react.useState)(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.industry) === null || ref === void 0 ? void 0 : ref.id), currentTypeId = ref5[0], setCurrentTypeId = ref5[1];
    (0,react.useEffect)(function() {
        if (!isEditMode) {
            var ref;
            setCurrentTypeId(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.industry) === null || ref === void 0 ? void 0 : ref.id);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref1 = fetchedUserInfo.industry) === null || ref1 === void 0 ? void 0 : ref1.id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputInfoSubGroup, {
        name: "業界",
        isEditMode: isEditMode,
        setEditMode: setEditMode,
        onSave: function() {
            updateUserInfo({
                industry_type_id: currentTypeId || 0
            });
        },
        onCancel: function() {
            var ref;
            setCurrentTypeId(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.industry) === null || ref === void 0 ? void 0 : ref.id);
        },
        children: isEditMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(common_DropdownWithSearch, {
            items: options,
            placeholder: "業界を検索する",
            limitHeightItems: true,
            className: (InputProfileSection_module_default()).customDropdown,
            currentValue: currentTypeId,
            title: "",
            onChangeValue: function(val) {
                return setCurrentTypeId(val);
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (InputProfileSection_module_default()).infoShow,
            children: ((ref2 = options.find(function(op) {
                return op.value === currentTypeId;
            })) === null || ref2 === void 0 ? void 0 : ref2.label) || BLANK_TEXT
        })
    });
};
var InputDesiredIndustryType = function() {
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), isEditMode = ref3[0], setEditMode = ref3[1];
    var ref4 = (0,react.useContext)(InputProfileSectionContext), industryTypes = ref4.industryTypes, updateUserInfo = ref4.updateUserInfo, fetchedUserInfo = ref4.fetchedUserInfo;
    var options = (0,react.useMemo)(function() {
        return industryTypes.map(function(type) {
            return {
                label: type.name,
                value: type.id
            };
        });
    }, [
        industryTypes
    ]);
    var ref5 = (0,react.useState)(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.desired_industry) === null || ref === void 0 ? void 0 : ref.id), currentTypeId = ref5[0], setCurrentTypeId = ref5[1];
    (0,react.useEffect)(function() {
        if (!isEditMode) {
            var ref;
            setCurrentTypeId(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.desired_industry) === null || ref === void 0 ? void 0 : ref.id);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref1 = fetchedUserInfo.desired_industry) === null || ref1 === void 0 ? void 0 : ref1.id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputInfoSubGroup, {
        name: "希望の業界",
        isEditMode: isEditMode,
        setEditMode: setEditMode,
        onSave: function() {
            updateUserInfo({
                desired_industry_type_id: currentTypeId || 0
            });
        },
        onCancel: function() {
            var ref;
            setCurrentTypeId(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.desired_industry) === null || ref === void 0 ? void 0 : ref.id);
        },
        children: isEditMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(common_DropdownWithSearch, {
            items: options,
            placeholder: "業界を検索する",
            limitHeightItems: true,
            className: (InputProfileSection_module_default()).customDropdown,
            currentValue: currentTypeId,
            title: "",
            onChangeValue: function(val) {
                return setCurrentTypeId(val);
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (InputProfileSection_module_default()).infoShow,
            children: ((ref2 = options.find(function(op) {
                return op.value === currentTypeId;
            })) === null || ref2 === void 0 ? void 0 : ref2.label) || BLANK_TEXT
        })
    });
};
var InputOccupation = function() {
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), isEditMode = ref3[0], setEditMode = ref3[1];
    var ref4 = (0,react.useContext)(InputProfileSectionContext), occupations = ref4.occupations, fetchedUserInfo = ref4.fetchedUserInfo, updateUserInfo = ref4.updateUserInfo;
    var options = (0,react.useMemo)(function() {
        return occupations.map(function(opa) {
            return {
                label: opa.name,
                value: opa.id
            };
        });
    }, [
        occupations
    ]);
    var ref5 = (0,react.useState)(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.occupation) === null || ref === void 0 ? void 0 : ref.id), currentOccupationId = ref5[0], setCurrentOccupationId = ref5[1];
    (0,react.useEffect)(function() {
        if (!isEditMode) {
            var ref;
            setCurrentOccupationId(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.occupation) === null || ref === void 0 ? void 0 : ref.id);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref1 = fetchedUserInfo.occupation) === null || ref1 === void 0 ? void 0 : ref1.id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputInfoSubGroup, {
        name: "職種",
        isEditMode: isEditMode,
        setEditMode: setEditMode,
        onSave: function() {
            updateUserInfo({
                occupation_id: currentOccupationId || 0
            });
        },
        onCancel: function() {
            var ref;
            setCurrentOccupationId(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.occupation) === null || ref === void 0 ? void 0 : ref.id);
        },
        children: isEditMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(common_DropdownWithSearch, {
            items: options,
            placeholder: "職種を検索する",
            limitHeightItems: true,
            className: (InputProfileSection_module_default()).customDropdown,
            currentValue: currentOccupationId,
            title: "",
            onChangeValue: function(val) {
                return setCurrentOccupationId(val);
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (InputProfileSection_module_default()).infoShow,
            children: ((ref2 = options.find(function(op) {
                return op.value === currentOccupationId;
            })) === null || ref2 === void 0 ? void 0 : ref2.label) || BLANK_TEXT
        })
    });
};
var InputChangeJobTime = function() {
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), isEditMode = ref3[0], setEditMode = ref3[1];
    var ref4 = (0,react.useContext)(InputProfileSectionContext), timeChangeJobs = ref4.timeChangeJobs, fetchedUserInfo = ref4.fetchedUserInfo, updateUserInfo = ref4.updateUserInfo, changeJobRef = ref4.changeJobRef;
    var options = (0,react.useMemo)(function() {
        return timeChangeJobs.map(function(time) {
            return {
                label: time.name,
                value: time.id
            };
        });
    }, [
        timeChangeJobs
    ]);
    var ref5 = (0,react.useState)((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.desired_time_change_job) === null || ref === void 0 ? void 0 : ref.id) || ""), timeChangeId = ref5[0], setTimeChangeId = ref5[1];
    (0,react.useEffect)(function() {
        if (!isEditMode) {
            var ref;
            setTimeChangeId((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.desired_time_change_job) === null || ref === void 0 ? void 0 : ref.id) || "");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref1 = fetchedUserInfo.desired_time_change_job) === null || ref1 === void 0 ? void 0 : ref1.id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputInfoSubGroup, {
        name: "転職希望",
        isEditMode: isEditMode,
        highlightName: !timeChangeId,
        setEditMode: setEditMode,
        onSave: function() {
            updateUserInfo({
                desired_time_change_job_id: timeChangeId || ""
            });
        },
        onCancel: function() {
            var ref;
            setTimeChangeId((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.desired_time_change_job) === null || ref === void 0 ? void 0 : ref.id) || "");
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: changeJobRef
            }),
            isEditMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(common_DropdownWithSearch, {
                items: options,
                placeholder: "転職希望時期",
                limitHeightItems: true,
                className: (InputProfileSection_module_default()).customDropdown,
                currentValue: timeChangeId,
                title: "",
                onChangeValue: function(val) {
                    return setTimeChangeId(val);
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (InputProfileSection_module_default()).infoShow,
                children: ((ref2 = options.find(function(op) {
                    return op.value === timeChangeId;
                })) === null || ref2 === void 0 ? void 0 : ref2.label) || BLANK_TEXT
            })
        ]
    });
};
var InputDesiredOccupation = function() {
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), isEditMode = ref3[0], setEditMode = ref3[1];
    var ref4 = (0,react.useContext)(InputProfileSectionContext), occupations = ref4.occupations, fetchedUserInfo = ref4.fetchedUserInfo, updateUserInfo = ref4.updateUserInfo;
    var options = (0,react.useMemo)(function() {
        return occupations.map(function(opa) {
            return {
                label: opa.name,
                value: opa.id
            };
        });
    }, [
        occupations
    ]);
    var ref5 = (0,react.useState)(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.desired_occupation) === null || ref === void 0 ? void 0 : ref.id), currentOccupationId = ref5[0], setCurrentOccupationId = ref5[1];
    (0,react.useEffect)(function() {
        if (!isEditMode) {
            var ref;
            setCurrentOccupationId(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.desired_occupation) === null || ref === void 0 ? void 0 : ref.id);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref1 = fetchedUserInfo.desired_occupation) === null || ref1 === void 0 ? void 0 : ref1.id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputInfoSubGroup, {
        name: "希望の職種",
        isEditMode: isEditMode,
        setEditMode: setEditMode,
        onSave: function() {
            updateUserInfo({
                desired_occupation_id: currentOccupationId || 0
            });
        },
        onCancel: function() {
            var ref;
            setCurrentOccupationId(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.desired_occupation) === null || ref === void 0 ? void 0 : ref.id);
        },
        children: isEditMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(common_DropdownWithSearch, {
            items: options,
            placeholder: "職種を検索する",
            limitHeightItems: true,
            className: (InputProfileSection_module_default()).customDropdown,
            currentValue: currentOccupationId,
            title: "",
            onChangeValue: function(val) {
                return setCurrentOccupationId(val);
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (InputProfileSection_module_default()).infoShow,
            children: ((ref2 = options.find(function(op) {
                return op.value === currentOccupationId;
            })) === null || ref2 === void 0 ? void 0 : ref2.label) || BLANK_TEXT
        })
    });
};
var WorkExperiencesSection = function() {
    var fetchedUserInfo = (0,react.useContext)(InputProfileSectionContext).fetchedUserInfo;
    var ref = (0,react.useState)((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.is_profile_job_public) || false), isPublic = ref[0], setIsPublic = ref[1];
    (0,react.useEffect)(function() {
        setIsPublic((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.is_profile_job_public) || false);
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.is_profile_job_public
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputInfoGroup, {
        id: "is_profile_job_public",
        name: "職歴",
        tooltipContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                "公開してからご本人以外の方からも",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                " 見られるようになります。"
            ]
        }),
        isPublic: isPublic,
        setIsPublic: setIsPublic,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputIndustryType, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputOccupation, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWorkExperiences, {})
        ]
    });
};
var StudyExperiencesSection = function() {
    var fetchedUserInfo = (0,react.useContext)(InputProfileSectionContext).fetchedUserInfo;
    var ref = (0,react.useState)((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.is_education_public) || false), isPublic = ref[0], setIsPublic = ref[1];
    (0,react.useEffect)(function() {
        setIsPublic((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.is_education_public) || false);
    }, [
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.is_education_public
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputInfoGroup, {
        id: "is_education_public",
        name: "学歴",
        tooltipContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                "公開してからご本人以外の方からも",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                " 見られるようになります。"
            ]
        }),
        isPublic: isPublic,
        setIsPublic: setIsPublic,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputStudyExperiences, {})
    });
};
var ConditionsInfoSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputInfoGroup, {
        id: "incomeInfoSection",
        name: "希望条件",
        tooltipContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                "公開してからご本人以外の方からも",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                " 見られるようになります。"
            ]
        }),
        disablePublic: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputChangeJobTime, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputDesiredIndustryType, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputDesiredOccupation, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputIncome, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputDesiredIncome, {})
        ]
    });
};
var ContactInfoSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputInfoGroup, {
        id: "contactInfoSectiom",
        name: "連絡先",
        tooltipContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                "公開してからご本人以外の方からも",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                " 見られるようになります。"
            ]
        }),
        disablePublic: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputPhoneNumber, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputContactEmail, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputProfileSection_InputAddress, {})
        ]
    });
};
var ProgressBarSection = function() {
    var ref;
    var ref1 = (0,react.useContext)(InputProfileSectionContext), fetchedUserInfo = ref1.fetchedUserInfo, changeJobRef = ref1.changeJobRef;
    if (!(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.total_fields)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if ((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.number_of_fields_entered) === (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.total_fields)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var percent = Math.floor((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.number_of_fields_entered) / (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.total_fields) * 100);
    var scrollToBottom = function() {
        window.scrollTo(0, document.body.scrollHeight);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (InputProfileSection_module_default()).progressBarSection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (InputProfileSection_module_default()).progressTitle,
                children: "情報入力の進捗"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (InputProfileSection_module_default()).progressInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (InputProfileSection_module_default()).progressBar,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((InputProfileSection_module_default()).notYetOverlay, (0,_define_property/* default */.Z)({}, (InputProfileSection_module_default()).fullWidth, percent === 0)),
                            style: {
                                width: "".concat(100 - percent, "%")
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (InputProfileSection_module_default()).number,
                        children: [
                            "(",
                            percent,
                            "%)"
                        ]
                    })
                ]
            }),
            !(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : (ref = fetchedUserInfo.desired_time_change_job) === null || ref === void 0 ? void 0 : ref.id) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (InputProfileSection_module_default()).alertText,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        onClick: function() {
                            var ref;
                            window.scrollTo({
                                behavior: "smooth",
                                left: 0,
                                top: (changeJobRef === null || changeJobRef === void 0 ? void 0 : (ref = changeJobRef.current) === null || ref === void 0 ? void 0 : ref.offsetTop) - 200
                            });
                        },
                        children: "転職希望"
                    }),
                    "を入力してください"
                ]
            }) : (!(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.email) || !(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.phone_number)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (InputProfileSection_module_default()).alertText,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        onClick: function() {
                            return scrollToBottom();
                        },
                        children: "連絡先"
                    }),
                    "を入力してください"
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/common/ConfirmDialog/index.tsx
var ConfirmDialog = __webpack_require__(78257);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/modules/InputProfileSection/index.tsx
















var InputProfileSectionContext = /*#__PURE__*/ (0,react.createContext)(null);
var InputProfileSection = function(param) {
    var onlyViewMode = param.onlyViewMode, userId = param.userId, setEditingProfileCount = param.setEditingProfileCount;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var isAuthInit = (0,global/* default */.Z)(function(state) {
        return state.isAuthInit;
    });
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var ref10 = (0,react.useState)(), fetchedUserInfo = ref10[0], setFetchedUserInfo = ref10[1];
    var ref11 = (0,react.useState)(false), openCheckPopup = ref11[0], setOpenCheckPopup = ref11[1];
    var changeJobRef = /*#__PURE__*/ react.createRef();
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        setEditingProfileCount(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userId
    ]);
    (0,react.useEffect)(function() {
        setEditingProfileCount(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var ref12 = (0,es.useQuery)("getMasterData", (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (isAuthInit) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", Promise.reject());
                case 2:
                    _ctx.next = 4;
                    return (0,user/* getProfileMasterData */.EV)();
                case 4:
                    return _ctx.abrupt("return", _ctx.sent);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        refetchOnWindowFocus: false,
        enabled: isAuthInit
    }), data = ref12.data, isFetched = ref12.isFetched;
    var ref13 = (0,es.useQuery)([
        "getUserInfoData",
        userId.toString(),
        onlyViewMode
    ], (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (isAuthInit) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", Promise.reject());
                case 2:
                    _ctx.next = 4;
                    return (0,user/* getUserProfileInfo */.sp)(userId);
                case 4:
                    return _ctx.abrupt("return", _ctx.sent);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        refetchOnWindowFocus: false,
        enabled: isAuthInit,
        onSuccess: function(data) {
            setFetchedUserInfo(data === null || data === void 0 ? void 0 : data.data);
        }
    }), isFetchedData = ref13.isFetched, isLoadingData = ref13.isLoading, refetchInfo = ref13.refetch, isFetchingData = ref13.isFetching;
    (0,react.useEffect)(function() {
        if (userId !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) || (fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.user_id) !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id)) return;
        if ((fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.is_info_sharing_approved) === false) {
            setOpenCheckPopup(true);
            (0,utils_user/* viewPolicyPopup */.Qc)();
        } else {
            setOpenCheckPopup(false);
        }
    }, [
        userId,
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.is_info_sharing_approved,
        fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.user_id,
        currentUser === null || currentUser === void 0 ? void 0 : currentUser.id, 
    ]);
    var ref14 = (0,es.useMutation)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(inputData) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,user/* updateUserProfileInfo */.il)(userId, inputData);
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(inputData) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSuccess: function() {
            void refetchInfo();
            setSnackbarMessage({
                type: "success",
                text: "保存しました"
            });
        },
        onError: function() {
            setSnackbarMessage({
                type: "error",
                text: "エラーが発生しました"
            });
        }
    }), updateUserInfo = ref14.mutate, isUpdating = ref14.isLoading;
    if (!isFetched || !isFetchedData || isLoadingData) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (InputProfileSection_module_default()).loading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
            name: "loading-anim-3",
            width: 30,
            height: 30
        })
    });
    if (!fetchedUserInfo) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (onlyViewMode && !(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.is_basic_information_public) && !(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.is_education_public) && !(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.is_profile_job_public) && !(fetchedUserInfo === null || fetchedUserInfo === void 0 ? void 0 : fetchedUserInfo.is_profile_public)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (InputProfileSection_module_default()).empty,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                    name: "empty",
                    width: 96,
                    height: 96
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: "プロフィール情報が公開されていません"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputProfileSectionContext.Provider, {
        value: {
            educationLevels: (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.education_levels) || [],
            employmentTypes: (data === null || data === void 0 ? void 0 : (ref1 = data.data) === null || ref1 === void 0 ? void 0 : ref1.employment_types) || [],
            industryTypes: (data === null || data === void 0 ? void 0 : (ref2 = data.data) === null || ref2 === void 0 ? void 0 : ref2.industry_types) || [],
            languageLevels: (data === null || data === void 0 ? void 0 : (ref3 = data.data) === null || ref3 === void 0 ? void 0 : ref3.language_levels) || [],
            languages: (data === null || data === void 0 ? void 0 : (ref4 = data.data) === null || ref4 === void 0 ? void 0 : ref4.languages) || [],
            nationalities: (data === null || data === void 0 ? void 0 : (ref5 = data.data) === null || ref5 === void 0 ? void 0 : ref5.nationalities) || [],
            occupations: (data === null || data === void 0 ? void 0 : (ref6 = data.data) === null || ref6 === void 0 ? void 0 : ref6.occupations) || [],
            salaryRanges: (data === null || data === void 0 ? void 0 : (ref7 = data.data) === null || ref7 === void 0 ? void 0 : ref7.salary_ranges) || [],
            timeChangeJobs: (data === null || data === void 0 ? void 0 : (ref8 = data.data) === null || ref8 === void 0 ? void 0 : ref8.time_change_jobs) || [],
            educationStatuses: (data === null || data === void 0 ? void 0 : (ref9 = data.data) === null || ref9 === void 0 ? void 0 : ref9.education_statuses) || [],
            onlyViewMode: onlyViewMode,
            setEditingProfileCount: setEditingProfileCount,
            fetchedUserInfo: fetchedUserInfo || {},
            updateUserInfo: updateUserInfo,
            changeJobRef: changeJobRef,
            isFetchingData: isFetchingData,
            isUpdating: isUpdating
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (InputProfileSection_module_default()).inputProfileSection,
            children: [
                !onlyViewMode && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBarSection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileSection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkExperiencesSection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StudyExperiencesSection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicInfoSection, {}),
                !onlyViewMode && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionsInfoSection, {}),
                !onlyViewMode && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactInfoSection, {}),
                !!currentUser && !onlyViewMode && openCheckPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmDialog/* default */.Z, {
                    open: openCheckPopup,
                    title: "<div style='font-size: 13px;'><p>当社の転職支援を受けるに際し、</p><p>人材紹介事業の<a target='_blank' href='".concat(utils/* USER_TERM_URL */.Du, "'>利用規約</a>と<a target='_blank' href='").concat(utils/* POLICY_URL */.Jk, "'>プライバシーポリシー</a></p><p>に同意頂く必要があります。</p><p>利用規約とプライバシーポリシーに同意して、</p><p>入力を行いますか？</p></div>"),
                    actionCloseFnc: function() {
                        (0,utils_user/* clickPolicyPopup */.hL)("disagree_btn");
                        setOpenCheckPopup(false);
                        void router.push("/");
                    },
                    actionSelectedFnc: function() {
                        (0,utils_user/* clickPolicyPopup */.hL)("agree_btn");
                        setOpenCheckPopup(false);
                        updateUserInfo({
                            is_info_sharing_approved: true
                        });
                    },
                    enableClickOutsideToClose: false,
                    yesText: "同意する",
                    noText: "同意しない"
                })
            ]
        })
    });
};
/* harmony default export */ var modules_InputProfileSection = (InputProfileSection);

// EXTERNAL MODULE: ./components/UserCoursesList/UserCoursesList.module.scss
var UserCoursesList_module = __webpack_require__(71526);
var UserCoursesList_module_default = /*#__PURE__*/__webpack_require__.n(UserCoursesList_module);
// EXTERNAL MODULE: ./service/course.ts
var course = __webpack_require__(11038);
// EXTERNAL MODULE: ./components/common/HorizontalCourseItemView/HorizontalCourseItemView.module.scss
var HorizontalCourseItemView_module = __webpack_require__(25561);
var HorizontalCourseItemView_module_default = /*#__PURE__*/__webpack_require__.n(HorizontalCourseItemView_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/common/HorizontalCourseItemView/index.tsx





// import CourseRatingView from 'components/common/CourseRatingView';



function HorizontalCourseItemView(param) {
    var course = param.course, _size = param.size, size = _size === void 0 ? "small" : _size;
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    if (!course) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var onCourseClick = function() {
        var ref;
        void router.push("/courses/".concat(course.id));
        (0,lib_esm/* track */.j)("View Course", {
            course_id: (ref = course.id) === null || ref === void 0 ? void 0 : ref.toString(),
            course_name: course.title
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((HorizontalCourseItemView_module_default()).courseItemView, (HorizontalCourseItemView_module_default())[size]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HorizontalCourseItemView_module_default()).thumbnailWrapper,
                children: ((ref = course.thumbnail_image_media) === null || ref === void 0 ? void 0 : ref.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/courses/".concat(course.id),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        style: {
                            display: "flex"
                        },
                        onClick: function() {
                            var ref;
                            (0,lib_esm/* track */.j)("View Course", {
                                course_id: (ref = course.id) === null || ref === void 0 ? void 0 : ref.toString(),
                                course_name: course.title
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: course.thumbnail_image_media.url,
                            height: (ref1 = course.thumbnail_image_media) === null || ref1 === void 0 ? void 0 : ref1.height,
                            width: (ref2 = course.thumbnail_image_media) === null || ref2 === void 0 ? void 0 : ref2.width,
                            alt: course.title
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HorizontalCourseItemView_module_default()).courseInfo,
                onClick: onCourseClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (HorizontalCourseItemView_module_default()).courseInfoBody,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HorizontalCourseItemView_module_default()).courseTitle,
                        children: course.title
                    })
                })
            })
        ]
    });
}
var MemoizedHorizontalCourseItemView = /*#__PURE__*/ react.memo(HorizontalCourseItemView);
/* harmony default export */ var common_HorizontalCourseItemView = (MemoizedHorizontalCourseItemView);

;// CONCATENATED MODULE: ./components/UserCoursesList/index.tsx










function UserCoursesList(param) {
    var creator = param.creator;
    var ref, ref1;
    var isAuthInit = (0,global/* default */.Z)(function(state) {
        return state.isAuthInit;
    });
    var coursesListRef = (0,react.useRef)();
    var ref2 = (0,es.useQuery)([
        "getUserCoursesList",
        creator === null || creator === void 0 ? void 0 : (ref = creator.id) === null || ref === void 0 ? void 0 : ref.toString()
    ], (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(!isAuthInit || !(creator === null || creator === void 0 ? void 0 : creator.id))) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", Promise.reject());
                case 2:
                    _ctx.next = 4;
                    return (0,course/* getUserCoursesList */.Y8)(creator === null || creator === void 0 ? void 0 : creator.id);
                case 4:
                    return _ctx.abrupt("return", _ctx.sent);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        enabled: isAuthInit,
        refetchOnWindowFocus: false,
        staleTime: 15 * 60 * 1000,
        cacheTime: 15 * 60 * 1000
    }), data = ref2.data, isFetched = ref2.isFetched;
    var courses = (data === null || data === void 0 ? void 0 : (ref1 = data.data) === null || ref1 === void 0 ? void 0 : ref1.courses) || [];
    var showNextBack = courses.length > 2;
    if (courses.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    var scrollShowMore = function(offset) {
        if (coursesListRef.current) {
            coursesListRef.current.scrollLeft += offset;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (UserCoursesList_module_default()).coursesListWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (UserCoursesList_module_default()).sectionTitle,
                children: [
                    creator === null || creator === void 0 ? void 0 : creator.name,
                    "さんのコース（",
                    courses.length,
                    "件）"
                ]
            }),
            isFetched && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (UserCoursesList_module_default()).coursesList,
                ref: coursesListRef,
                children: [
                    showNextBack && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (UserCoursesList_module_default()).backBtn,
                        onClick: function() {
                            scrollShowMore(-250);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "foward-arrow",
                            width: 24,
                            height: 24
                        })
                    }),
                    showNextBack && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (UserCoursesList_module_default()).nextBtn,
                        onClick: function() {
                            scrollShowMore(250);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "foward-arrow",
                            width: 24,
                            height: 24
                        })
                    }),
                    courses.map(function(course, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(common_HorizontalCourseItemView, {
                            course: course,
                            size: courses.length === 1 ? "big" : courses.length === 2 ? "medium" : "small"
                        }, "".concat(course === null || course === void 0 ? void 0 : course.id, "-").concat(index));
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./common/utils/payment.ts
var payment = __webpack_require__(60612);
;// CONCATENATED MODULE: ./pages/[username]/index.tsx

























var ProfilePage = function(props) {
    var ref, ref1, ref2;
    var username = props.username;
    var ref3 = (0,react.useState)((0,utils/* parseJSON */.Rx)(props.userProfile)), userProfile = ref3[0], setUserProfile = ref3[1];
    var router = (0,next_router.useRouter)();
    var tab = router.query.tab;
    var paywall = router.query.paywall;
    var ref4 = (0,react.useState)(false), autoShowedPaywall = ref4[0], setAutoShowedPaywall = ref4[1];
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var isCurrentUser = username === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.username);
    var isAuthInit = (0,global/* default */.Z)(function(state) {
        return state.isAuthInit;
    });
    var shouldRefetchCurrentProfile = (0,timeline/* default */.ZP)(function(state) {
        return state.shouldRefetchCurrentProfile;
    });
    var shouldRefetchProfile = (0,timeline/* default */.ZP)(function(state) {
        return state.shouldRefetchProfile;
    });
    var showPaymentDialog = (0,global/* default */.Z)(function(state) {
        return state.showPaymentDialog;
    });
    var ref5 = (0,react.useState)(0), selectedTab = ref5[0], setSelectedTab = ref5[1];
    var ref6 = (0,react.useState)(0), editingProfileCount = ref6[0], setEditingProfileCount = ref6[1];
    (0,react.useEffect)(function() {
        if (tab === api/* ProfilePageTab.ProfileInput */.Cz.ProfileInput) {
            if (isCurrentUser) {
                setSelectedTab(2);
            } else {
                setSelectedTab(1);
            }
        } else if (tab === api/* ProfilePageTab.SavedPosts */.Cz.SavedPosts) {
            if (isCurrentUser) {
                setSelectedTab(1);
            } else {
                setSelectedTab(0);
            }
        } else {
            setSelectedTab(0);
        }
    }, [
        isCurrentUser,
        tab
    ]);
    var updateTabParam = (0,react.useCallback)(function(i) {
        var tab;
        if (i === 0) {
            tab = api/* ProfilePageTab.PostsList */.Cz.PostsList;
        } else if (i === 1) {
            if (isCurrentUser) {
                tab = api/* ProfilePageTab.SavedPosts */.Cz.SavedPosts;
            } else {
                tab = api/* ProfilePageTab.ProfileInput */.Cz.ProfileInput;
            }
        } else if (i === 2) {
            if (isCurrentUser) {
                tab = api/* ProfilePageTab.ProfileInput */.Cz.ProfileInput;
            } else {
                tab = api/* ProfilePageTab.PostsList */.Cz.PostsList;
            }
        }
        if (tab) {
            void router.push({
                pathname: "/".concat(username),
                query: {
                    tab: tab
                }
            }, "/".concat(username, "?tab=").concat(tab), {
                shallow: true
            });
        }
    }, [
        isCurrentUser,
        router,
        username
    ]);
    var handleSelectTab = function(i) {
        updateTabParam(i);
    };
    (0,react.useEffect)(function() {
        if (isCurrentUser) return;
        if (isAuthInit && (userProfile === null || userProfile === void 0 ? void 0 : userProfile.id)) {
            var ref;
            (0,lib_esm/* track */.j)("View Creator Profile", {
                creator_user_id: userProfile === null || userProfile === void 0 ? void 0 : (ref = userProfile.id) === null || ref === void 0 ? void 0 : ref.toString(),
                creator_badge: userProfile === null || userProfile === void 0 ? void 0 : userProfile.badge,
                creator_follower_number: userProfile === null || userProfile === void 0 ? void 0 : userProfile.follow_count
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userProfile === null || userProfile === void 0 ? void 0 : userProfile.id
    ]);
    (0,react.useEffect)(function() {
        if (tab !== api/* ProfilePageTab.ProfileInput */.Cz.ProfileInput) return;
        var routeChangeStart = function(url) {
            if (!isCurrentUser) return;
            if (tab !== api/* ProfilePageTab.ProfileInput */.Cz.ProfileInput) return;
            if (editingProfileCount <= 0) return;
            if (url.startsWith("/".concat(currentUser === null || currentUser === void 0 ? void 0 : currentUser.username, "?tab=profile"))) return;
            var ok = confirm("プロフィールの変更が保存されていません。ページから移動しますか。");
            if (!ok) {
                router.events.emit("routeChangeError");
                throw "Abort route change. Please ignore this error.";
            }
        };
        router.events.on("routeChangeStart", routeChangeStart);
        return function() {
            router.events.off("routeChangeStart", routeChangeStart);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isCurrentUser,
        tab,
        editingProfileCount
    ]);
    (0,react.useEffect)(function() {
        if (autoShowedPaywall) return;
        if (!(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) || isCurrentUser || paywall !== "true") return;
        if (!(userProfile === null || userProfile === void 0 ? void 0 : userProfile.is_creator)) return;
        var isAbleToSub = (userProfile === null || userProfile === void 0 ? void 0 : userProfile.is_creator) && (userProfile === null || userProfile === void 0 ? void 0 : userProfile.is_open_for_subscription);
        var canUpGradePlan = (0,utils_user/* isAbleToUpgradePlan */.Dn)(userProfile);
        var isSubscribed = userProfile === null || userProfile === void 0 ? void 0 : userProfile.is_subscribed;
        var renewMode = (0,payment/* isRenewPrimeSubStatus */.WJ)(userProfile);
        var showingSubButton = (userProfile === null || userProfile === void 0 ? void 0 : userProfile.is_creator) && (!isSubscribed || renewMode || canUpGradePlan);
        if (!showingSubButton || !isAbleToSub) return;
        showPaymentDialog({
            creator: userProfile
        });
        setAutoShowedPaywall(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        autoShowedPaywall,
        currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
        paywall,
        showPaymentDialog,
        userProfile === null || userProfile === void 0 ? void 0 : userProfile.id, 
    ]);
    var isMobile = (0,utils/* useMediaQuery */.ac)("(max-width: 767px)");
    // profile
    var ref7 = (0,es.useQuery)([
        "getProfile",
        username
    ], (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (username) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", Promise.reject());
                case 2:
                    return _ctx.abrupt("return", (0,user/* getUserProfile */.et)(username));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        enabled: isAuthInit && !!username,
        refetchOnWindowFocus: false,
        retry: function(count, e) {
            var ref;
            var error = e;
            if (((ref = error.response) === null || ref === void 0 ? void 0 : ref.status) === 404) {
                return false;
            }
            if (count >= 2) {
                return false;
            }
            return true;
        },
        onSuccess: function(data) {
            var profile = data === null || data === void 0 ? void 0 : data.data;
            setUserProfile(profile);
        }
    }), refetch = ref7.refetch, isError = ref7.isError;
    (0,react.useEffect)(function() {
        if (shouldRefetchCurrentProfile) {
            void refetch();
        }
    }, [
        shouldRefetchCurrentProfile,
        refetch
    ]);
    (0,react.useEffect)(function() {
        if (shouldRefetchProfile && isCurrentUser) {
            void refetch();
        }
    }, [
        shouldRefetchProfile,
        refetch,
        isCurrentUser
    ]);
    // Metadata
    var titleText = ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.name) ? userProfile.name : "") + ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.username) ? " (@".concat(userProfile.username, ")") : "") + (userProfile ? " | " : "") + "PostPrime | 投資を楽しく学べる！";
    var getNextPageParamSavedPost = (0,react.useCallback)(function(lastPage, pages) {
        var ref;
        var posts = lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.data) === null || ref === void 0 ? void 0 : ref.posts;
        if (posts && posts.length > 0) {
            return pages.length + 1;
        }
    }, []);
    var getNextPageParamProfile = (0,react.useCallback)(function(lastPage) {
        var ref, ref1;
        var posts = lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.data) === null || ref === void 0 ? void 0 : ref.posts;
        if (posts && posts.length > 0 && (lastPage === null || lastPage === void 0 ? void 0 : (ref1 = lastPage.data) === null || ref1 === void 0 ? void 0 : ref1.next_key)) {
            var ref2;
            return lastPage === null || lastPage === void 0 ? void 0 : (ref2 = lastPage.data) === null || ref2 === void 0 ? void 0 : ref2.next_key;
        }
    }, []);
    var canonicalUrl = (userProfile === null || userProfile === void 0 ? void 0 : userProfile.username) === "PostPrime" ? "https://postprime.com" : "".concat(env/* SITE_BASE_URL */.B, "/").concat(username);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: titleText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "".concat((userProfile === null || userProfile === void 0 ? void 0 : userProfile.bio) ? userProfile === null || userProfile === void 0 ? void 0 : userProfile.bio : "ログインして、SNSでお金を学ぼう!")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "".concat(env/* SITE_BASE_URL */.B, "/").concat(username)
                    }, "ogurl"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "profile"
                    }, "ogtype"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: titleText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: "".concat((userProfile === null || userProfile === void 0 ? void 0 : userProfile.bio) ? userProfile === null || userProfile === void 0 ? void 0 : userProfile.bio : "ログインして、SNSでお金を学ぼう!")
                    }),
                    (userProfile === null || userProfile === void 0 ? void 0 : userProfile.avatar_url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.avatar_url) || ""
                    }, "ogimage"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content: "".concat(env/* SITE_BASE_URL */.B, "/").concat(username)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: titleText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: "".concat((userProfile === null || userProfile === void 0 ? void 0 : userProfile.bio) ? userProfile === null || userProfile === void 0 ? void 0 : userProfile.bio : "ログインして、SNSでお金を学ぼう!")
                    }),
                    (userProfile === null || userProfile === void 0 ? void 0 : userProfile.avatar_url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.avatar_url) || ""
                    }, "twimage"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: canonicalUrl
                    })
                ]
            }),
            isError ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ProfilePage_module_default()).emptyWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "empty",
                        width: 96,
                        height: 96
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProfilePage_module_default()).emptyText,
                        children: "このユーザーが存在しません"
                    })
                ]
            }) : userProfile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ProfilePage_module_default()).profilePageWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile/* default */.Z, {
                        user: userProfile,
                        hideBorder: true
                    }),
                    currentUser ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Tabs, {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        selectedTabClassName: (ProfilePage_module_default()).selected,
                        selectedIndex: selectedTab,
                        onSelect: handleSelectTab,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.TabList, {
                                className: (ProfilePage_module_default()).tabList,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Tab, {
                                        className: (ProfilePage_module_default()).tab,
                                        id: "yourPosts",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (ProfilePage_module_default()).tabContent,
                                            children: isCurrentUser ? "あなたの投稿" : "投稿一覧"
                                        })
                                    }),
                                    isCurrentUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Tab, {
                                        className: (ProfilePage_module_default()).tab,
                                        id: "savedPosts",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (ProfilePage_module_default()).tabContent,
                                            children: "保存した投稿"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Tab, {
                                        className: (ProfilePage_module_default()).tab,
                                        id: "proifleInfo",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (ProfilePage_module_default()).tabContent,
                                            children: "プロフィール"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.TabPanel, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (ProfilePage_module_default()).timelineSection,
                                    children: [
                                        isCurrentUser && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(CreatePostBox/* default */.Z, {
                                            isProfilePage: true
                                        }),
                                        userProfile && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserCoursesList, {
                                            creator: userProfile
                                        }),
                                        (userProfile === null || userProfile === void 0 ? void 0 : userProfile.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineSection/* default */.Z, {
                                            apiUrl: "/profiles/timelines/v2/".concat(userProfile === null || userProfile === void 0 ? void 0 : userProfile.id),
                                            queryKey: [
                                                api/* PostParentKey.ProfilePosts */.rO.ProfilePosts,
                                                userProfile === null || userProfile === void 0 ? void 0 : (ref = userProfile.id) === null || ref === void 0 ? void 0 : ref.toString(), 
                                            ],
                                            queryParamKey: "next_key",
                                            noResultMessage: "まだ投稿がありません",
                                            getNextPageParam: getNextPageParamProfile,
                                            defaultPageParam: ""
                                        })
                                    ]
                                })
                            }),
                            isCurrentUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.TabPanel, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ProfilePage_module_default()).timelineSection,
                                    children: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineSection/* default */.Z, {
                                        apiUrl: "/posts/".concat(userProfile === null || userProfile === void 0 ? void 0 : userProfile.id, "/saved_posts"),
                                        queryKey: [
                                            api/* PostParentKey.SavePosts */.rO.SavePosts,
                                            userProfile === null || userProfile === void 0 ? void 0 : (ref1 = userProfile.id) === null || ref1 === void 0 ? void 0 : ref1.toString(), 
                                        ],
                                        queryParamKey: "page",
                                        noResultMessage: "保存した投稿がありません",
                                        getNextPageParam: getNextPageParamSavedPost,
                                        defaultPageParam: 1
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.TabPanel, {
                                children: userProfile && /*#__PURE__*/ (0,jsx_runtime.jsx)(modules_InputProfileSection, {
                                    onlyViewMode: !isCurrentUser,
                                    userId: userProfile === null || userProfile === void 0 ? void 0 : userProfile.id,
                                    setEditingProfileCount: setEditingProfileCount
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProfilePage_module_default()).timelineSection,
                        children: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineSection/* default */.Z, {
                            apiUrl: "/profiles/timelines/v2/".concat(userProfile === null || userProfile === void 0 ? void 0 : userProfile.id),
                            queryKey: [
                                api/* PostParentKey.ProfilePosts */.rO.ProfilePosts,
                                userProfile === null || userProfile === void 0 ? void 0 : (ref2 = userProfile.id) === null || ref2 === void 0 ? void 0 : ref2.toString(), 
                            ],
                            queryParamKey: "next_key",
                            noResultMessage: "まだ投稿がありません",
                            getNextPageParam: getNextPageParamProfile,
                            defaultPageParam: ""
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _username_ = (ProfilePage);


/***/ }),

/***/ 71526:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"coursesListWrapper":"UserCoursesList_coursesListWrapper__jl0Eo","sectionTitle":"UserCoursesList_sectionTitle__HGre_","coursesList":"UserCoursesList_coursesList__nsbnf","nextBtn":"UserCoursesList_nextBtn__IvL1M","backBtn":"UserCoursesList_backBtn__Y71aL"};

/***/ }),

/***/ 88859:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customSwitch":"CustomSwitch_customSwitch__dE936","switch":"CustomSwitch_switch__hvWNL","flag":"CustomSwitch_flag___oG9R","root":"CustomSwitch_root__9oRth","switchBase":"CustomSwitch_switchBase__Jlqhr","checked":"CustomSwitch_checked__9cKcU","track":"CustomSwitch_track__zQ77J","focusvisible":"CustomSwitch_focusvisible__KoBsN","thumb":"CustomSwitch_thumb__LNDYr"};

/***/ }),

/***/ 86903:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"timeInputWrapper":"DateInput_timeInputWrapper__zxG9Q","withTime":"DateInput_withTime__Jek9_","datePicker":"DateInput_datePicker__BAFk4","close":"DateInput_close__MOkO0","arrow":"DateInput_arrow__U5ahL","timeInput":"DateInput_timeInput__DAnoT","tableTimeInput":"DateInput_tableTimeInput__EHd_W"};

/***/ }),

/***/ 97514:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"Dropdown_dropdown__LbfH_","value":"Dropdown_value__uqWP3","caret":"Dropdown_caret__apo4x","menuWrapper":"Dropdown_menuWrapper__ndzuJ","limitHeightItems":"Dropdown_limitHeightItems__tGkDX","toogleRight":"Dropdown_toogleRight__Ru8q9","items":"Dropdown_items__tBLHd","title":"Dropdown_title__JpPZW","item":"Dropdown_item__tWnxG","check":"Dropdown_check__71GBF","label":"Dropdown_label__HgsXX"};

/***/ }),

/***/ 18370:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"Dropdown_dropdown__MD9gF","value":"Dropdown_value__N0jcx","close":"Dropdown_close__v1M0D","caret":"Dropdown_caret__4IH1F","menuWrapper":"Dropdown_menuWrapper__iDrVT","limitHeightItems":"Dropdown_limitHeightItems___GR0h","toogleRight":"Dropdown_toogleRight__kOv3P","items":"Dropdown_items__NJdRw","title":"Dropdown_title__KBmQr","item":"Dropdown_item__MSck3","check":"Dropdown_check__w5c3B","label":"Dropdown_label__xNsTy"};

/***/ }),

/***/ 16980:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"help":"HelpPopover_help__I1NfI","tooltip":"HelpPopover_tooltip__bmWpa"};

/***/ }),

/***/ 25561:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"courseItemView":"HorizontalCourseItemView_courseItemView__hcZsO","thumbnailWrapper":"HorizontalCourseItemView_thumbnailWrapper__ymggA","courseInfo":"HorizontalCourseItemView_courseInfo__avEno","courseTitle":"HorizontalCourseItemView_courseTitle__4tf_x","ratingAndCategory":"HorizontalCourseItemView_ratingAndCategory__R_yzY","categoryItem":"HorizontalCourseItemView_categoryItem__R_Up0","big":"HorizontalCourseItemView_big__NpBIu","medium":"HorizontalCourseItemView_medium__AA4IP","small":"HorizontalCourseItemView_small__dc2A_"};

/***/ }),

/***/ 4414:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputGroup":"InputWithLabel_inputGroup__Zpz1w","header":"InputWithLabel_header___PD6o","requiredFlag":"InputWithLabel_requiredFlag__GncTA","value":"InputWithLabel_value__l9c8N","requiredAlert":"InputWithLabel_requiredAlert__1SblJ","error":"InputWithLabel_error__VwRoz"};

/***/ }),

/***/ 32409:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputProfileSection":"InputProfileSection_inputProfileSection__MMzPI","empty":"InputProfileSection_empty__mKzDn","loading":"InputProfileSection_loading__KbAfH","inputInfoGroup":"InputProfileSection_inputInfoGroup__dzSw4","groupHeader":"InputProfileSection_groupHeader__DdAat","groupName":"InputProfileSection_groupName__BoDyE","rightSide":"InputProfileSection_rightSide__JlinO","publicHelpIcon":"InputProfileSection_publicHelpIcon__Uf_Jt","warningText":"InputProfileSection_warningText__FOOFx","inputInfoSubGroup":"InputProfileSection_inputInfoSubGroup__GsoGO","editMode":"InputProfileSection_editMode__y_MfW","subGroupHeader":"InputProfileSection_subGroupHeader__HkbNO","subGroupName":"InputProfileSection_subGroupName__zsRSy","highlightName":"InputProfileSection_highlightName__uPxLs","errorMessenge":"InputProfileSection_errorMessenge__SiT71","inputTextContent":"InputProfileSection_inputTextContent__GGyS_","inputTextContentOneLine":"InputProfileSection_inputTextContentOneLine__zJWRZ","textContent":"InputProfileSection_textContent__m8Fo0","languagesEditMode":"InputProfileSection_languagesEditMode__PcmW_","addLanguage":"InputProfileSection_addLanguage__5v6_F","languageItem":"InputProfileSection_languageItem__XMx2B","index":"InputProfileSection_index___PsFG","languageLevelSelect":"InputProfileSection_languageLevelSelect__PwfMH","deleteIcon":"InputProfileSection_deleteIcon__r_VEe","languages":"InputProfileSection_languages____X96","name":"InputProfileSection_name__QGwRj","level":"InputProfileSection_level__aVVUT","skills":"InputProfileSection_skills__NWxZu","subItem":"InputProfileSection_subItem__tR_UW","subItemName":"InputProfileSection_subItemName__l4u0s","subItemTime":"InputProfileSection_subItemTime__TXF5N","skillsEditMode":"InputProfileSection_skillsEditMode__d_0VN","addSkill":"InputProfileSection_addSkill__z464Z","addSubSkill":"InputProfileSection_addSubSkill__CcZKK","subItemIndex":"InputProfileSection_subItemIndex__ELi_w","subItemYear":"InputProfileSection_subItemYear__YWbzT","subItemMonth":"InputProfileSection_subItemMonth___XCMV","infoShow":"InputProfileSection_infoShow__U1ocC","workExperiences":"InputProfileSection_workExperiences__yANq2","workExperience":"InputProfileSection_workExperience__wqpLJ","companyName":"InputProfileSection_companyName__v3P7I","timeInfo":"InputProfileSection_timeInfo__sFMwU","workExperiencesEditMode":"InputProfileSection_workExperiencesEditMode__VZg8_","exIndex":"InputProfileSection_exIndex__pdaLh","changePositionWrapper":"InputProfileSection_changePositionWrapper__h2HE4","down":"InputProfileSection_down__0Feew","up":"InputProfileSection_up__fxIcT","contractType":"InputProfileSection_contractType__lsEk_","exTitle":"InputProfileSection_exTitle__B8xSE","addEx":"InputProfileSection_addEx__3SYsO","addWorkEx":"InputProfileSection_addWorkEx__ea5GU","timelineTitle":"InputProfileSection_timelineTitle__R6pV2","dateInputGroup":"InputProfileSection_dateInputGroup__1okp6","timeline":"InputProfileSection_timeline__K_0IK","event":"InputProfileSection_event__OWkih","department":"InputProfileSection_department__DfUn1","dateRange":"InputProfileSection_dateRange___dy_K","studyExperiences":"InputProfileSection_studyExperiences__iDm0_","studyExperience":"InputProfileSection_studyExperience__wUbFd","studyTitle":"InputProfileSection_studyTitle__crO7N","studyName":"InputProfileSection_studyName__u7wW4","studyTime":"InputProfileSection_studyTime__kgcdP","studyContent":"InputProfileSection_studyContent__Mlhjc","studyExperiencesEditMode":"InputProfileSection_studyExperiencesEditMode__wPnAP","status":"InputProfileSection_status__9kglu","studyExDes":"InputProfileSection_studyExDes__mxWOx","addSchool":"InputProfileSection_addSchool__RBwzi","dateInput":"InputProfileSection_dateInput__rwcmH","customDropdown":"InputProfileSection_customDropdown__mkCp_","inputAdressEditMode":"InputProfileSection_inputAdressEditMode__69zV2","addressInputGroup":"InputProfileSection_addressInputGroup__WnVyW","devide":"InputProfileSection_devide__tRIJC","searchBtn":"InputProfileSection_searchBtn__rRWYE","inputNameEditMode":"InputProfileSection_inputNameEditMode__2rtqg","nameInputGroup":"InputProfileSection_nameInputGroup__4m6Bs","progressBarSection":"InputProfileSection_progressBarSection__7rv0B","progressTitle":"InputProfileSection_progressTitle__43BOc","alertText":"InputProfileSection_alertText__DCUTq","progressInfo":"InputProfileSection_progressInfo__5pUsO","number":"InputProfileSection_number__8zUg0","progressBar":"InputProfileSection_progressBar__5QM_Z","notYetOverlay":"InputProfileSection_notYetOverlay__QZQTT","in-out":"InputProfileSection_in-out__y3BGz","fullWidth":"InputProfileSection_fullWidth__8HnNB","checkboxWrapper":"InputProfileSection_checkboxWrapper__lWcXO"};

/***/ }),

/***/ 35214:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"timelineSection":"ProfilePage_timelineSection__sAH1L","tabList":"ProfilePage_tabList__axpyu","tab":"ProfilePage_tab__CS42o","tabContent":"ProfilePage_tabContent__rBgx5","selected":"ProfilePage_selected__3O8z5","emptyWrapper":"ProfilePage_emptyWrapper__D2FUa","emptyText":"ProfilePage_emptyText__r7Fix","profilePageWrapper":"ProfilePage_profilePageWrapper__hQQdD","addPostBtn":"ProfilePage_addPostBtn__aQi9B"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6007,6310,9122,4850,8369,5489,1471,4872,5052,453,7393,3962,6548,1038,4201,2424,9774,2888,179], function() { return __webpack_exec__(31932); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);